import { Injectable, ApplicationRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StringVariable {
  public language$ = new BehaviorSubject<string>('en');
  public currentLanguage: string = 'en';
  public email: any = 'Email';
  public country: any = 'Country';
  public countryMobileNo: any = 'Country Code';
  public mobileNumber: any = 'Mobile Number';
  public grabberName: any = 'Grabber Name';
  public name: any = 'Name';
  public adminId: any = 'Admin Id';
  public customer: any = 'Customer';
  public addCustomer: any = 'Add Customer';
  public createCustomer: any = 'Create Customer';
  public receiver: any = 'Receiver';
  public addReceiver: any = 'Add Receiver';
  public createReceiver: any = 'Create Receiver';
  public viewReceiver: any = 'View Receiver';

  public countryOfficialName: any = 'Country Official Name';
  public countryAlpha2: any = 'Country Alpha 2';
  public countryAlpha3: any = 'Country Alpha 3';
  public code: any = 'Code';
  public affiliatePartner: any = 'Affiliate Partner';
  public city: any = 'City';
  public pincode: any = 'Pincode';
  public accessRole = 'Access Role';

  public password: any = 'Password';
  public newPassword: any = 'New Password';
  public currentPassword: any = 'Current Password';
  public changePassword: string = 'Change Password';
  public forgotPassword: string = 'Forgot Password';

  public authenticationApps: any = 'Authentication Apps';
  public twoFactorLabel: any = 'Two Factor';
  public twoFactorAuth: any = 'Two Factor Auth';
  public verify: any = 'Verify';
  public mobileAndEmailVerification: any = 'Mobile And Email Verification';
  public otpDeliveryChannel: any = 'OTP Delivery Channel';

  public enableTwoFactorAuth: any = 'Enable Two Factor Auth';
  public enableTrustedDeviceCheck: any = 'Enable Trusted Device Check';
  public trustedDeviceCheck: any = 'Trusted Device Check';
  public enableLiteMode: any = 'Enable Lite Mode';
  public approverLevel: any = 'Approver Level';
  public riskGradeConfig: any = 'Risk Grade Config';

  public description: any = 'Description';
  public documentCategories: any = 'Document Categories';
  public stakeHolderDocumentCategory: any = 'Stake Holder Document Category';
  public actionAfterExpiry: any = 'Action After Expiry';
  public expiryWarningBufferDays: any = 'Expiry Warning Buffer Days';
  public expirable: any = 'Expirable';
  public categoryName: any = 'Category Name';
  public stakeHoldersIdText: any = 'Stake Holders';
  public serviceable: any = 'Serviceable';
  public businessStakeHoldersId: any =
    'Business Stake Holders / UBOs Identifier text';
  public otpSender: any = 'OTP Sender Implementation';
  public addressSchema: any = 'Address Schema';
  public address: any = 'Address';
  public createdDate: any = 'Created Date';
  public businessIdentificationFieldSchema: any =
    'Business Identification Field Schema';
  public individualIdentifierFieldSchema: any =
    'Individual Identification Field Schema';
  public adminFieldSchema: any = 'Admin Field Schema';
  public partnerFieldSchema: any = 'Partner Field Schema';
  public customerFieldSchema: any = 'Customer Field Schema';
  public paymentDetailsFieldSchema: any = 'Payment Details Field Schema';
  public partnerProcessorImpl: any = 'Partner Processor Impl';

  public adminKyc: any = 'Admin KYC';
  public partnerKyc: any = 'Partner KYC';
  public customerKyc: any = 'Customer KYC';
  public affiliatePartnerKyc: any = 'Affiliate Partner KYC';
  public riskScoreForAdmins: string = 'Risk Score of country For Admins';
  public riskScore: string = 'Risk Score';
  public docsIncompleteRiskScore: string = 'Docs Incomplete Risk Score';
  public livenessIncompleteRiskScore: string = 'Liveness Incomplete Risk Score';
  public amlIncompleteRiskScore: string = 'AML Incomplete Risk Score';
  public amsIncompleteRiskScore: string = 'AMS Incomplete Risk Score';
  public pepIncompleteRiskScore: string = 'PEP Incomplete Risk Score';


  public mandatory: any = 'Mandatory';
  public fieldName: any = 'Field Name';
  public fieldType: any = 'Field Type';
  public fieldRegex: any = 'Field Regex';
  public order: any = 'Order';
  public fieldDescription: any = 'Field Description';
  public fieldHint: any = 'Field Hint';
  public hint: any = 'Hint';
  public selectOptions: any = 'Select Options';
  public selectOptionValue: any = 'Select Option Value';
  public selectOptionDescription: any = 'Select Option Description';
  public hasToBeUnique: any = 'HasTo Be Unique';
  public postalCode: any = 'Postal Code';
  public cityOrTown: any = 'City Or Town';
  public fieldSchemaFieldSelectOptionType: any =
    'Field Schema Field Select Option Type';
  public cmplxFldOrientation: any = 'Complex Field Orientation';
  public mask: any = 'Mask';
  public selectQuery: any = 'Select Query';
  public exQuery: any =
    "select * from execute_global_field_queries('select isd_code::text, known_name::text from countries limit 50') 1st Param - Value, 2nd Param - Description";
  public areaWghtOnCmplxFld: any = 'Area Weight On Complex Field';
  public repeatMinTimes: any = 'Repeat Min Times';
  public expiryAfterDays: any = 'Expiry After Days';
  public expiryDateField: any = 'Expiry Date';
  public toDate: any = 'To Date';
  public fromDate: any = 'From Date';
  public effectiveFromDate: any = 'Effective From Date';
  public date: any = 'Date';

  public queryString: any = 'Search';
  public searchPartner: any = 'Search Partner';
  public expiryType: any = 'Expiry Type';
  public partnerType: any = 'Partner Type';
  public managedBy: any = 'Managed By';
  public createUnderAdmin: any = 'Create Under Admin';
  public status: any = 'Status';
  public accountStatus: any = 'Account Status';
  public updateUserAccountStatus: any = 'Update User Account Status';
  public customerProfileType: any = 'Customer Profile Type';
  public adminUser: any = 'Admin Users';
  public weight: any = 'Weight';

  public fromCurrency: any = 'From Currency';
  public toCurrency: any = 'To Currency';
  public Currency: any = 'Currency';
  public currencyCode: any = 'Currency Code';

  public documentStatus: any = 'Document Status';
  public userType: any = 'User Type';
  public user: any = 'User';
  public documentCategory: any = 'Document Category';
  public totalDocumentCategory: any = 'Total Document Category';
  public totalFieldSchema: any = 'Total Field Schema';
  public dateRangeType: any = 'Date Range Type';
  public comment: any = 'Comment';
  public resendOtp: any = 'Resend OTP in';

  public alreadyHaveAnOtp: any = 'Already Have An Otp';
  public sendOtp: any = 'Send Otp';
  public resendbtn: any = 'Resend';
  public buttonLogout: any = 'Logout';
  public donebtn: any = 'Done';
  public submitBtn: any = 'Submit';
  public updateBtn: any = 'Update';
  public action: any = 'Action';
  public actions: any = 'Actions';
  public filterbtn: any = 'Filter';
  public applyFilters: any = 'Apply Filters';

  public accessControl: any = 'Access Control';
  public accessControls: any = 'Access Controls';
  public method: any = 'Method';
  public httpMethod: any = 'Http Method';

  public adminCode: any = 'Admin Code';
  public implClass: any = 'Impl Class';
  public implClassName: any = 'IMPL Class Name';
  public currencies: any = 'Currencies';
  public sendingCurrencies: any = 'Sending Currencies';
  public receivingCurrencies: any = 'Receiving Currencies';
  public countries: any = 'Countries';
  public sendingCountries: any = 'Sending Countries';
  public receivingCountries: any = 'Receiving Countries';
  public modeOfPayment: any = 'Mode Of Payment';
  public modeOfPaymentOrPayout: any = 'Mode Of Payment Or Payout';
  public reqPerMinute: any = 'Req Per Minute';
  public partialRefundAllowed: any = 'Partial Refund Allowed';
  public perTransactionValLimitRequest: any =
    'Per Transaction Value Limit Request';
  public admin: any = 'Admin';
  public addAdmin: any = 'Add Admin';
  public isActiveRequired: any = 'Is Required Active';
  public paymentInstrumentCode = 'Payment Instrument Code';
  public relationship = 'Relationship';
  public addRelationship: any = 'Add Relationship';
  public sendingPartnerName: any = 'Sending Partner Name';
  public sendingPartnerCode: any = 'Sending Partner Code';


  public apiKeyUsed = 'Api Key Used';
  public tokenTire = 'Token Tire';
  public successful = 'Successful';
  public api = 'Api';

  public partner: any = 'Partner';
  public addPartner: any = 'Add Partner';
  public paymentInstrument: any = 'Payment Instrument';
  public addPaymentInstrument: any = 'Add Payment Instrument';

  public amount: any = 'Amount';

  public type: any = 'Type';
  public emailsToNotify: any = 'Emails To Notify';
  public notifyAllUser: any = 'Notify All User';
  public notifyViaEmail: any = 'Notify Via Email';
  public notifyViaNotification: any = 'Notify Via Notification';
  public userTargetedNotification: any = 'User Targeted Notification';
  public notifyViaEmailIfNotReadWithInMinutes: any =
    'Notify Via Email If Not Read With In Minutes';
  public propagateReadStatusAcrossRelatedNotification: any =
    'Propagate Read Status Across Related Notification';
  public propagateNotificationToUpperLevelIfNotRead: any =
    'Propagate Notification To Upper Level If Not Read';
  public thresholdMinutesToReadNotification: any =
    'Threshold Minutes To Read Notification';
  public notificationBannerType: any = 'Notification Banner Type';
  public notificationBannerDestination: any = 'Notification Banner Destination';
  public thresholdDaysToTransformToBanner: any =
    'Threshold Days To Transform To Banner';

  public PaymentDetailsSchema = 'Payment Details Schema';
  public addMorePaymentDetailsSchema = 'Add more Payment Details Schema Value';
  public label = 'label';
  public profile: string = 'Profile';
  public profileType: string = 'Profile Type';
  public livenessAndSanctionCheckSettings: string =
    'Liveness And Sanction Check Settings';
  public livenessSanctionCheckAdmin: string =
    'Liveness and Sanction Check Admin';
  public livenessSanctionCheckPartner: string =
    'Liveness and Sanction Check Partner';
  public livenessSanctionCheckCustomer: string =
    'Liveness and Sanction Check Customer';
  public updateTheme: string = 'Update Theme';
  public lcTimeBoundCriteria: string = 'Liveness Check Time Bound Criteria';
  public lcTimeBoundCriteriaUnit: string =
    'Liveness Check Time Bound Criteria Unit';
  public lcTimeBoundCriteriaValue: string =
    'Liveness Check Time Bound Criteria Value';
  public lcFrequencyBoundCriteria: string =
    'Liveness Check Frequency Bound Criteria';
  public lcFrequencyBoundCriteriaValue: string =
    'Liveness Check Frequency Bound Criteria Value';
  public scTimeBoundCriteria: string = 'Sanction Check Time Bound Criteria';
  public scTimeBoundCriteriaUnit: string =
    'Sanction Check Time Bound Criteria Unit';
  public scTimeBoundCriteriaValue: string =
    'Sanction Check Time Bound Criteria Value';
  public scTimeBoundCriteriaValueType: string =
    'Sanction Check Time Bound Criteria Value Type';
  public scFrequencyBoundCriteria: string =
    'Sanction Check Frequency Bound Criteria';
  public scFrequencyBoundCriteriaValue: string =
    'Sanction Check Frequency Bound Criteria Value';
  public scFrequencyBoundCriteriaValueType: string =
    'Sanction Check Frequency Bound Criteria Value Type';
  public liveness: string = 'Liveness';
  public livenessCheck: string = 'Liveness Check';
  public sanction: string = 'Sanction';
  public sanctionCheck: string = 'Sanction Check';

  public weekScheduleForPartner = 'Week Schedule';

  public riskGrade: string = 'Risk Grade';
  public riskGradeLevel: string = 'Level';
  public riskGradeSeverity: string = 'Severity';
  public riskGradeThreshold: string = 'Threshold (%)';
  public riskGradeHoldTransaction: string = 'Hold Transaction';
  public riskGradePauseAccount: string = 'Pause Account';
  public riskGradeApprovalOptions: string = 'Approval Options';

  public iSar: string = 'I-SAR';
  public sarCreatedDate: string = 'Created Date';
  public sarTransactionCode: string = 'Transaction Code';
  public sarExplanation: string = 'Explanation';

  public updateSmtp: string = 'Update SMTP Configuration';
  public smtpConfiguration: string = 'SMTP Configuration';
  public smtpServerHost: string = 'SMTP Server Host';
  public smtpServerPort: string = 'SMTP Server Port';
  public smtpUserName: string = 'SMTP User Name';
  public smtpPassword: string = 'SMTP Password';
  public smtpSenderEmail: string = 'SMTP Sender Email';
  public smtpAuthEnabled: string = 'SMTP Auth Enabled';
  public smtpSSLEnabled: string = 'SMTP SSL Enabled';
  public smtpStartTlsEnabled: string = 'SMTP Start TLS Enabled';

  public receiverProfileType: string = 'Receiver Profile Type';

  public paymentMethod: string = 'Payment Method';
  public payoutMethod: string = 'Payout Method';
  public usedMyPayoutMethod: string = 'Used my payment method';

  public changePasswordWithRemitall: string = 'Change Password with RemitAll';
  public isRequired: string = 'is required';
  public enter: string = 'Enter';
  public resetPasswordWithRemitAll: string = 'Reset Password with RemitAll';
  public signinToContinue: string = 'Sign in to continue';
  public validEmailAddress: string = 'Email must be a valid email address';
  public login: string = 'Log In';
  public notHaveAnAccount: string = "Don't have an account ?";
  public signupNow: string = 'Signup now';
  public supportEmail: string = 'Support Email';
  public subUser: string = 'Sub User';
  public addSubUser: string = 'Add Sub User';
  public verifyYourEmail: string = 'Verify your email';
  public confirm: string = 'Confirm';
  public signUpToContinue: string = 'Sign up to continue';
  public select: string = 'Select';
  public firstName: string = 'First Name';
  public optional: string = '(Optional)';
  public middleName: string = 'Middle Name';
  public lastName: string = 'Last Name';
  public dateOfBirth: string = 'Date Of Birth';
  public countryCodeFormobilenumber: string = 'Country Code for mobile number';

  public passwordMinimumLength: string = 'Password minimum length is 6 characters';
  public passwordUpperCaseLetter: string = 'Password must contain at least 1 upper case letter';
  public passwordLowerCaseLetter: string = 'Password must contain at least 1 lower case letter';
  public passwordSpecialCharacter: string = 'Password must contain at least 1 special character';
  public passwordContainANumber: string = 'Password must contain a number';
  public signUp: string = 'Sign Up';
  public save: string = 'Save';
  public saveAddress: string = 'Save Address';
  public saveIndividualIdentifier: string = 'Save Individual Identifier';
  public saveMiscellaneousFields: string = 'Save Miscellaneous Fields';
  public saveBusinessDetails: string = 'Save Business Details';
  public stepVerification: string = '2-Step Verification';
  public timeBasedOtpMobiile: string = 'Time-Based Otp from your mobile';
  public emailOtp: string = 'Otp on your email';
  public second: string = 'seconds';
  public setup: string = 'Setup';
  public otp: string = 'OTP';
  public sendMoney: string = 'Send Money';
  public settings: string = 'Settings';
  public overview: string = 'Overview';
  public add: string = 'Add';
  public addNew: string = 'Add New';
  public addMore: string = 'Add More';

  public edit: string = 'Edit';
  public close: string = 'Close';
  public fieldSelectOption: string = 'Field Select Option';
  public complexFeild: string = 'Complex Field';
  public repeat: string = 'Repeat';
  public identifier: string = 'Identifier';
  public individualIdentifier: string = 'Individual Identifier';
  public timeBoundCriteria: string = 'LC Time Bound Criterias';
  public freqBoundCriteria: string = 'LC Freq Bound Criterias';
  public scTimeBoundCriteria2: string = 'SC Time Bound Criterias';
  public scFrequencyBoundCriteria2: string = 'SC Freq Bound Criterias';
  public lcUpdateTimeBoundCriteria: string = 'LC Update Time Bound Criteria';
  public lcUpdateFreqBoundCriteria: string = 'LC Update Freq Bound Criteria';
  public scUpdateTimeBoundCriteria: string = 'SC Update Time Bound Criteria';
  public scUpdateFreqBoundCriteria: string = 'SC Update Freq Bound Criteria';
  public scTimeBoundCriteriaTimeUnitValue: string = 'SC Time Bound Criteria Time Unit Value';
  public scTimeBoundCriteriaTimeUnit: string = 'SC Time Bound Criteria Time Unit';
  public lcTimeFreqCriteriaValueLimit: string = 'LC Time Freq Criteria Value Limit';
  public lcFreqBoundCriteriaValueLimit: string = 'LC Freq Bound Criteria Value Limit';
  public scFreqBoundCriteriaValueLimit: string = 'SC Freq Bound Criteria Value Limit';
  public scFreqBoundCriteriaValueType: string = 'SC Freq Bound Criteria Value Type';

  public repeatChild: string = 'Repeat Child';
  public makeNonMandatory: string = 'Make Not Mandatory';
  public kyc: string = 'KYC';
  public requiredMessage: string = 'This is required';
  public fieldSchema: string = 'Field Schema';
  public minimumValue: string = 'Minimum value for this field is 0';
  public maximumValue10: string = 'Maximum value for this field is 10';
  public maximumValue: string = 'Maximum value for this field is 100';
  public greaterThan100: string = 'Risk score value is greater than 100';

  public documents: string = 'Documents';
  public viewDocument: string = ' View Document';
  public uploadDocuments: string = 'Upload Documents';
  public attachDocuments: string = 'Attach Documents';
  public cancel: string = 'Cancel';
  public limit: string = 'Limit';
  public available: string = 'available';
  public repayment: string = 'Repayment'
  public transactions: string = 'Transactions';
  public updateLimit: string = 'Update Limit';
  public increaseLimit: string = 'Increase Limit';
  public decreaseLimit: string = 'Decrease Limit';
  public updateCreditLinePayment: string = 'Update Credit Line Payment';
  public paused: string = 'Paused';
  public active: string = 'Active';
  public updateQueueMasterState: string = 'Update Queue Master State';
  public queueMasterState: string = 'Queue Master State';
  public refreshInterval: string = 'Refresh Interval';
  public selectDateRange: string = 'Select Date Range';
  public data: string = 'Data';
  public create: string = 'Create';
  public clicktoCopy: string = 'Click to copy';
  public share: string = 'Share';
  public open: string = 'Open';
  public updateType: string = 'Update Type';
  public global: string = 'Global';
  public individual: string = 'Individual';
  public updateForAllAdminUsers: string = 'Update For All Admin Users';
  public reset: string = 'Reset';
  public updateAllCustomer: string = 'Update For All Customer Users';
  public customerUser: string = 'Customer User';
  public updatePartnerUser: string = 'Update For All Partner Users';
  public partnerUser: string = 'Partner User';
  public impersonationOtp: string = 'Impersonation OTP';
  public pleaseContacttheParentUser: string = 'Please contact the Parent User for more details';
  public businessDetails: string = 'Business Details';
  public miscellaneousFields: string = 'Miscellaneous Fields';
  public businessIndentifier: string = 'Business Indentifier';
  public individualIndentifier: string = 'Individual Indentifier';
  public adminCustomerRiskParams: string = 'Admin Customer risk params';
  public riskParams: string = 'Risk Params';
  public occupation: string = 'Occupation';
  public addOccupation: string = 'Add Occupation';
  public occupationList: string = 'Occupation List';
  public editOccupationRiskScore: string = ' Edit Occupation RiskScore';
  public ageRangeBracket: string = 'Age Range Bracket';
  public ageRangeBracketList: string = 'Age Range Bracket List ( Lower bound )';
  public age: string = 'Age';
  public addAgeRangeBracket: string = 'Add Age Range Bracket';
  public editAgeRangeBracket: string = 'Edit age range bracket';
  public clientPlatform: string = 'Client Platform';
  public platform: string = 'Platform';
  public twoFactorNotRequiredTimeout: string = 'Two Factor Not Required Timeout (in ms)';
  public transactionEstimateTimeout: string = 'Transaction Estimate Timeout (in ms)';
  public transactionReportTemplates: string = 'Transaction Report Templates';
  public transactionColumns: string = 'Transaction Columns';
  public noTransactionColumns: string = 'No transaction columns selected';

  public senderCustomerColumns: string = 'Sender Customer Columns';
  public noSenderCustomerColumns: string = 'No sender customer columns selected';
  public receiverCustomerColumns: string = 'Receiver Customer Columns';
  public noReceiverCustomerColumns: string = 'No receiver customer columns selected';
  public senderPartnerColumns: string = 'Sender Partner Columns';
  public noSenderPartnerColumns: string = 'No sender partner columns selected';
  public receiverPartnerColumns: string = 'Receiver Partner Columns';
  public noReceiverPartnerColumns: string = 'No receiver partner columns selected';
  public sendingPartnerColumns: string = 'Sending Partner Columns';
  public receivingPartnerColumns: string = 'Receiving Partner Columns';

  public emailReportConfiguration: string = 'Email Report Configuration';
  public reconciliationToEmail: string = 'Reconciliation - To Email';
  public enterValidEmail: string = 'Please enter a valid email';
  public reconciliationCCEmails: string = 'Reconciliation - CC Emails';
  public emailEnterMessage: string = 'To insert multiple emails press ENTER after each entry, you may provide bulk emails with comma seperated emails.'
  public accountManagerToEmail: string = 'Account Manager - To Email';
  public accountManagerCCEmails: string = 'Account Manager - CC Emails';
  public managementToEmail: string = 'Management - To Email'
  public managementCCEmails: string = 'Management - CC Emails';
  public weeklyReportToEmail: string = 'Weekly Report - To Email'
  public weeklyReportCCEmails: string = 'Weekly Report - CC Emails';

  public templates: string = 'Templates';
  public templateName: string = 'Template Name';
  public arrangeColumns: string = 'Arrange Columns';
  public preview: string = 'Preview';
  public paidTxns: string = 'Paid Txns';
  public processingTxns: string = 'Processing Txns';
  public paidAmount: string = 'Paid Amount';
  public charges: string = 'Charges';
  public refundCharge: string = 'Refund Charge';
  public loading: string = 'Loading';
  public sending: string = 'Sending';
  public receiving: string = 'Receiving';
  public modeOfPayout: string = 'Mode Of Payout';
  public chargeExclusive: string = 'Charge Exclusive';
  public chargeInclusive: string = 'Charge Inclusive';
  public recipientGets: string = 'Recipient gets';
  public toSend: string = 'To Send';
  public totaltoPay: string = 'Total to Pay';
  public payingWith: string = 'Paying with';
  public change: string = 'Change';
  public receiverDetails: string = 'Receiver Details'
  public receiverName: string = 'Receiver Name';
  public receiverCode: string = 'Receiver Code';
  public paymentDetails: string = 'Payment Details';
  public paymentMode: string = 'Payment Mode';
  public addPaymentDetails: string = 'Please Add Payment Details for Receiver';
  public purpose: string = 'Purpose';
  public totalCharge: string = 'Total charge';
  public createdbyme: string = 'Created by me';
  public sent: string = 'Sent';
  public exchangeRate: string = 'Exchange Rate';
  public sendingPartner: string = 'Sending Partner';
  public receivingPartner: string = 'Receiving Partner';
  public sender: string = 'Sender';
  public receipt: string = 'Receipt';
  public printReceipt: string = 'Print Receipt';
  public initiateReturn: string = 'Initiate Return';
  public checkLiveness: string = 'Check Liveness';
  public skipLiveness: string = 'Skip Liveness';
  public initiatePayment: string = 'Initiate Payment';
  public paymentDone: string = 'Payment Done';
  public payoutStart: string = 'Payout Start';
  public payoutDone: string = 'Payout Done';
  public overrideSARRisk: string = 'Override SAR Risk';
  public overrideKyc: string = 'Override KYC';
  public overrideLiveness: string = 'Override Liveness';
  public overrideSanction: string = 'Override Sanction';
  public completeReturn: string = 'Complete Return';
  public markasReturnFailed: string = 'Mark as Return Failed';
  public rejectReturn: string = 'Reject Return';
  public senderDetails: string = 'Sender Details';
  public payoutDetails: string = 'Payout Details';
  public transactionBreakdown: string = 'Transaction Breakdown';
  public amountSent: string = 'Amount Sent';
  public amountReceived: string = 'Amount Received';
  public totalCharged: string = 'Total Charged';
  public verifications: string = 'Verifications';
  public approveRiskCheck: string = 'Approve Risk Check';
  public canBeApprovedBy: string = 'Can be approved by';
  public resolved: string = 'Resolved';
  public message: string = 'Message';
  public reason: string = 'Reason';
  public addReason: string = 'Add Reason';
  public skipLivenessCheck: string = 'Skip Liveness Check';
  public reasonForSkippingLivenessCheck: string = 'Please provide a reason for skipping liveness check';
  public noReasonsFoundForAdmin: string = 'No reasons found for admin';

  public dropFilesHereOrClickToUpload: string = 'Drop files here or click to upload';
  public maximumFileSize: string = 'Maximum file size:';
  public sendFile: string = 'Send File';
  public createTransaction: string = 'Create Transaction';
  public documentName: string = 'Document Name';
  public state: string = 'State';
  public createNewTransaction: string = 'Create New Transaction';
  public downloadTransactionReport: string = 'Download Transaction Report';
  public selectFileFormat: string = 'Select File Format';
  public exportViaEmail: string = 'Report too large, Please export via email.';
  public sendReportToMyEmail: string = 'Send report to my email';
  public downloadAutomatically: string = 'Your download should start automatically. If not, you can';
  public downloadItHere: string = 'download it here.';
  public upload: string = 'Upload';
  public fileType: string = 'File Type';
  public viewDocumentDetails: string = 'View Document Details';
  public document: string = 'Document';
  public documentType: string = 'Document Type';
  public documentNumber: string = 'Document Number';
  public documentDetails: string = 'Document Details';

  public viewLivenessAndSanctionCheckSetting: string = 'View Liveness and Sanction Check Setting';
  public pleaseEntervalidSMTPServerHost: string = 'Please enter a valid SMTP Server Host';
  public enterValidSMTPServerPort: string = 'Please enter a valid SMTP Server Port';
  public entervalidUserName: string = 'Please enter a valid User Name';
  public entervalidPassword: string = 'Please enter a valid Password';
  public smtpAuthEnabledRequired: string = 'SMTP Auth Enabled is Required';
  public smtpSSLEnabledRequired: string = 'SMTP SSL Enabled is Required';
  public smtpStartTLSEnabledRequired: string = 'SMTP Start TLS Enabled is Required';
  public themeColorPrimary: string = 'Theme Color Primary';
  public usingFormatOption: string = 'Using format option';
  public themeColorSecondary: string = 'Theme Color Secondary';
  public customUrl: string = 'Custom URL';
  public enterValidCustomUrl: string = 'Please enter a valid Custom Url';
  public applicationName: string = 'Application Name';
  public footerMessage: string = 'Footer Message';
  public logo: string = 'Logo';
  public icon: string = 'Icon';
  public banner: string = 'Banner';
  public recommendedDimensions: string = 'Recommended dimensions';
  public pixels: string = 'pixels';
  public only: string = 'Only';
  public pngImagesAllowed: string = 'Only PNG images are allowed';
  public send: string = 'Send';
  public cf: string = 'CF';
  public cFUrl: string = 'CF Url';
  public hostedZone: string = 'Hosted Zone';
  public viewWeeklySchedule: string = 'View Weekly Schedule';
  public selectDay: string = 'Select Day';
  public startTime: string = 'Start Time';
  public endTime: string = 'End Time';
  public weeklySchedule: string = 'Weekly Schedule';
  public selectFirstExceptionschedule: string = 'Please select a partner first to add exception schedule';
  public viewExceptionSchedule: string = 'View Exception Schedule';
  public addNewExceptionSchedule: string = 'Add New Exception Schedule';
  public delete: string = 'Delete';
  public innerCharges: string = 'Inner Charges';
  public maxCumulativeValue: string = 'Max Cumulative Value';
  public slabs: string = 'Slabs';
  public updateCharge: string = 'Update Charge';
  public visibilityLevel: string = 'Visibility Level';
  public chargeName: string = 'Charge Name';
  public fromAmount: string = 'From Amount';
  public toAmount: string = 'To Amount';
  public flat: string = 'Flat';
  public percentage: string = 'Percentage';
  public typeRequired: string = 'Type is required';
  public maxLength100: string = 'Max length is 100';
  public fieldSchemaSelectTypeRequired: string = 'Field Schema Select Option Type is required';
  public addmoreFieldSchema: string = 'Add more Field Schema';
  public addField: string = 'Add Field';
  public fieldValue: string = 'Field Value';
  public qualifier: string = 'Qualifier';
  public preferredPartner: string = 'Preferred Partner';
  public modesOfPayment: string = 'Modes Of Payment';
  public modesOfPayout: string = 'Modes Of Payout';
  public effectiveToDate: string = 'Effective To Date';
  public pertransactionValueLimit: string = 'Per Transaction Value Limit';
  public transactionCountLimit: string = 'Transaction Count Limit';
  public timeFrameValue: string = 'Time Frame Value';
  public timeFrameUnit: string = 'Time Frame Unit';
  public timeFrame: string = 'Time Frame';
  public transactionValueLimit: string = 'Transaction Value Limit';
  public timeUnit: string = 'Time Unit';
  public timeUnitValue: string = 'Time Unit Value';
  public fxMargin: string = 'Fx Margin';
  public absoluteRate: string = 'Absolute Rate';
  public rate: string = 'Rate';
  public rateStrategy: string = 'Rate Strategy';
  public dynamicMargin: string = 'Dynamic Margin';
  public staticFxRate: string = 'Static Fx Rate';
  public refundStrategy: string = 'Refund Strategy';
  public transactionProcessStrategy: string = 'Transaction Process Strategy';
  public paymentProviderInstrument: string = 'Payment Provider Instrument';
  public commission: string = 'Commission';
  public updateQualifier: string = 'Update Qualifier';

  public contactDetails: string = 'Contact Details';
  public contactEmail: string = 'Contact Email';
  public contactMobileNumber: string = 'Contact Mobile Number';
  public purposeList: string = 'Purpose List';
  public profileStatus: string = 'Profile Status';
  public updateUserApproverLevel: string = 'Update User Approver Level';
  public timeout: string = 'Timeout';
  public mobileNumberIsInvalid: string = 'Mobile Number is invalid';
  public information: string = 'Information';
  public individualUBO: string = 'Individual UBO(s)';
  public nickName: string = 'Nick Name';
  public changeReceiverProfileType: string = 'Change Receiver Profile Type';
  public ownerCustomerEmail: string = 'Owner Customer Email';
  public ownerCustomerCountry: string = 'Owner Customer Country';
  public ownerCustomerName: string = 'Owner Customer Name';
  public digits: string = 'Digits';
  public closeViewDetails: string = 'Close & View Details';
  public UltimateBeneficialOwnerDetails: string = 'UBO (Ultimate Beneficial Owner) Details';
  public viewReceivers: string = 'View Receivers';
  public viewAdditionalDetails: string = 'View Additional Details';
  public signedUpFromPartnerSide: string = 'Is Signed Up From Partner Side?';
  public partnerCode: string = 'Partner Code';
  public transactionList: string = 'Transaction List';
  public transactionAmountLimitPerTransaction: string = 'Transaction Amount Limit Per Transaction';
  public transactionAmountLimit: string = 'Transaction Amount Limit';
  public transactionFrequencyLimit: string = 'Transaction Frequency Limit';
  public showAll: string = 'Show All';
  public showLatest: string = 'Show Latest';
  public profileRisk: string = 'Profile Risk';
  public riskOverride: string = 'Risk Override';
  public profileRiskCheckFor: string = 'Profile Risk Check For';
  public createLiveness: string = 'Create Liveness';
  public updateRiskParams: string = 'Update Risk Params';
  public timeframe: string = 'Timeframe';
  public lcTimeboundCriteriaValueRequired: string = 'LC Time bound Criteria Value Required';
  public lcFrequencyboundValueRequired: string = 'LC Frequency bound Value Required';
  public lcTimeFreqCriteriaValueLimitIsRequired: string = 'LC Time Freq Criteria Value Limit is required';
  public scTimeboundCriteriaUnitRequired: string = 'SC Time bound Criteria Unit is Required';
  public scTimeboundCriteriaValueRequired: string = 'SC Time bound Criteria Value is Required';
  public scTimeBoundCriteriaTimeUnitIsRequired: string = 'SC Time Bound Criteria Time Unit is required';
  public scTimeboundCriteriaValueTypeRequired: string = 'SC Time bound Criteria Value Type Required';
  public scTimeBoundCriteriaTimeUnitValueIsRequired: string = 'SC Time Bound Criteria Time Unit Value is required';
  public scFreqBoundCriteriaValueLimitIsRequired: string = 'SC Freq Bound Criteria Value Limit is required';
  public scFreqBoundCriteriaValueTypeIsRequired: string = 'SC Freq Bound Criteria Value Type is required';
  public scFrequencyBoundCriteriaIsRequired: string = 'SC Frequency Bound Criteria is required'
  public scFrequencyBoundCriteriaValueIsRequired: string = 'Sanction Check Frequency Bound Criteria Value is required';
  public scFrequencyBoundCriteriaValueTypeIsRequired: string = 'Sanction Check Frequency Bound Criteria Value Type is required';
  public customerswithExpiredDocuments: string = 'Customers with Expired Documents';
  public showCustomerUsersProfileType: string = 'Show Customer Users by Profile Type';
  public lastTransaction: string = 'Last Transaction';
  public lastActive: string = 'Last Active';
  public closeViewDetailsPage: string = 'Close & View Details Page';
  public back: string = 'Back';
  public documentCategorySuggestion: string = 'Document Category Suggestion';
  public approvedOrRejectedBy: string = 'Approved Or Rejected By';
  public view: string = 'View';
  public download: string = 'Download'
  public selectIMPLName: string = 'Select IMPL Name';
  public implNamerequired: string = 'IMPL Name is required';
  public runIntervalUnit: string = 'Run interval Unit';
  public rateofRequestPerMinute: string = ' Rate of Request Per Minute';
  public requestPerMinute: string = 'Request Per Minute ';
  public rateofRequest: string = 'Rate of Request';
  public ownerName: string = 'Owner Name';
  public implName: string = 'IMPL Name';
  public runIntervalValue: string = 'Run Interval Value';
  public addForexGrabber: string = 'Add Forex Grabber';
  public intervalUnit: string = 'Interval Unit';
  public intervalValue: string = 'Interval Value';
  public requiredCurrencyPairs: string = 'Required Currency Pairs';
  public addForex: string = 'Add Forex';
  public effectiveFrom: string = 'Effective From';
  public effectiveTo: string = 'Effective To';
  public pair: string = 'Pair';
  public value: string = 'Value';
  public addNotification: string = 'Add Notification';
  public pressEnterToAddMultipleEmail: string = 'To insert multiple emails press ENTER after each entry, you may provide bulk emails with comma seperated emails'
  public selectProcessorImpl: string = 'Select Processor Impl';
  public businessIdentifier: string = 'Business Identifier';
  public capabilities: string = 'Capabilities';
  public sendingCapabilities: string = 'Sending Capabilities';
  public receivingCapabilities: string = 'Receiving Capabilities';

  public timeBoundCriteria2: string = 'Time Bound Criteria';
  public frequencyBoundCriteria: string = 'Frequency Bound Criteria';
  public day: string = 'Day';
  public startHour: string = 'Start Hour';
  public startMin: string = 'Start Min';
  public endHour: string = 'End Hour';
  public endMin: string = 'End Min';
  public exceptionSchedule: string = 'Exception Schedule';
  public noExceptionScheduleExistsuser: string = 'No exception schedule exists for this user';
  public addCapabilitiesQualifier: string = 'Add Capabilities Qualifier';
  public capabilityType: string = 'Capability Type';
  public lcTimeboundCriteriaUnitRequired: string = 'LC Time bound Criteria Unit is required';
  public riskCalculator: string = 'Risk Calculator';
  public addRiskCalculator: string = 'Add Risk Calculator';
  public addRiskImplementation: string = 'Risk Implementation';
  public riskFactor: string = 'Risk Factor';
  public addRiskFactor: string = 'Add Risk Factor';
  public riskName: string = 'Risk Name';
  public contributionRisk: string = 'Contribution Risk %';
  public oneAmongContributedRiskScoreOrWeightFields: string = 'One among Contributed Risk Score or Weight fields';
  public onlyOneOfContributedRiskScoreOrWeightFields: string = 'Only one of Contributed Risk Score or Weight fields';
  public attachToAdminForCustomer: string = 'Attach to Admin for Customer';
  public riskCalculatorsLinkedToUserProfiles: string = 'Risk Calculators linked to User Profiles';
  public riskCalculatorsApplicableForCustomers: string = 'Risk Calculators applicable for Customers';
  public riskImplementation: string = 'Risk Implementation';
  public attachExistingRiskCalculator: string = 'Attach Existing Risk Calculator';
  public riskScoreEvaluation: string = 'Risk Score Evaluation';
  public validityTime: string = 'Validity Time';
  public calculatorCode: string = 'Calculator Code';
  public factorCode: string = 'Factor Code';
  public contributedRiskScore: string = 'Contributed Risk Score';
  public attachedRiskFactorImplementation: string = 'View Attached Risk Factor Implementation';
  public riskFactorImplementation: string = 'Risk Factor Implementation';
  public addRiskFactorImplementation: string = 'Add Risk Factor Implementation';
  public editRiskFactorImplementation: string = 'Edit Risk Factor Implementation'
  public updateRiskFactorImplementationClass: string = 'Update Risk Factor Implementation Class';
  public addRiskGradeApprovalOptions: string = 'Add Risk Grade Approval Options';
  public updateRiskGradeApprovalOptions: string = 'Update Risk Grade Approval Options';
  public valid: string = 'Valid';
  public errorMessage: string = 'Error Message';
  public dynamicVariables: string = 'Dynamic Variables'
  public useForCustomerRiskCalculation?: string = 'Use For Customer Risk Calculation?';
  public riskCalculationUsage: string = 'Risk Calculation Usage';
  public yes: string = 'Yes';
  public no: string = 'No';
  public implementationClass: string = 'Implementation Class';
  public params: string = 'Params';
  public paramsEnterMessage: string = ' To insert multiple params press ENTER after each entry, you may provide bulk parameters with comma seperated after each.'
  public customerLevelRiskCalculationsApplicable: string = 'Customer Level Risk Calculations Applicable';
  public optionNo: string = 'Option No.';
  public level1Officer: string = 'Level 1 Officer';
  public level2Officer: string = 'Level 2 Officer';
  public level3Officer: string = 'Level 3 Officer';
  public level4Officer: string = 'Level 4 Officer';
  public level5Officer: string = 'Level 5 Officer';
  public remove: string = 'Remove';
  public routeCode: string = 'Route Code';
  public paymentRoute: string = 'Payment Route';
  public addPaymentRoute: string = 'Add Payment Route';
  public goOnline: string = 'Go Online';
  public killSite: string = 'Kill Site';
  public copyAllAccessControls: string = 'Copy all access controls from existing access role';
  public addNewAccessRole: string = 'Add New Access Role';
  public selectAll: string = 'Select all';
  public unselectAll: string = 'Unselect all';
  public affiliateUser: string = 'Affiliate User';
  public addAffiliateUser: string = 'Add Affiliate User';
  public serverDownMessage: string = 'Oops, unable to connect to server. please retry in';
  public addToHomeScreen: string = 'Add to Home Screen';
  public enter6DigitCode: string = ' Please enter the 6 digit code sent to'
  public dashboard: string = 'Dashboard';
  public location: string = 'Location';
  public countryDetails: string = 'Country Details';
  public creditLineStatement: string = 'Credit Line Statement';
  public creditLine: string = 'Credit Line';
  public transactionDetails: string = 'Transaction Details';
  public qualifierDetails: string = 'Qualifier Details';
  public adminDetails: string = 'Admin Details';
  public receivers:string = 'Receivers';
  public customerDetails:string = 'Customer Details';
  public paymentInstrumentMapping:string = 'Payment Instrument Mapping';
  public grabbers:string = 'Grabbers';
  public forexGrabbers:string = 'Forex Grabbers';
  public forex:string = 'Forex';
  public notificationConfig:string = 'Notification Config';
  public partnerDetails:string = 'Partner Details';
  public addRiskImplementationClass:string = 'Add Risk Implementation Class';
  public riskCalculators: string = 'Risk Calculators';
  public riskManagement: string = 'Risk Management';
  public riskFactorImplementationAttached:string = 'Risk Factor Implementation Attached to Risk Calculator';
  public attachedRiskFactor:string = 'Attached Risk Factor Implementation Classes to';
  public riskFactors: string = 'Risk Factors';
  public paymentRouteDetails: string = 'Payment Route Details';
  public routes: string = 'Routes';
  public sites:string = 'Sites';
  public userLogs:string = 'User Logs';
  public userManagement:string = 'User Management';
  public affiliatePartnerUser:string = 'Affiliate Partner User';
  public affiliateDetails:string = 'Affiliate Details';
  public subUserDetails:string = 'SubUser Details';
  public paymentInstrumentDetails:string = 'Payment Instrument Details';
  public updateAccountStatus:string = 'Update Account Status';
  public userStatus:string = 'User Status';

  public selectAdmin: string = 'Select Admin';
  public selectCustomer: string = 'Select Customer';
  public selectCountry: string = 'Select Country';
  public selectCity: string = 'Select City';
  public selectCurrencies: string = 'Select Currencies';
  public selectCurrency: string = 'Select Currency';
  public selectPartner: string = 'Select Partner';
  public selectAffiliatePartner: string = 'Select Affiliate Partner';
  public selectSubUser: string = 'Select Sub User';
  public selectUser: string = 'Select User';
  public selectReceiver: string = 'Select Receiver';
  public selectAccessRole: string = 'Select Access Role';
  public selectAccessControls: string = 'Select Access Controls';
  public selectPartnerType: string = 'Select Partner Type';
  public selectManagedBy: string = 'Select Managed By';
  public selectCreateUnderAdmin: string = 'Select Create Under Admin';
  public selectOccupation: string = 'Select Occupation';
  public selectRelationship: string = 'Select Relationship';
  public selectReceiverProfileType: string = 'Select Receiver Profile Type';
  public selectCustomerProfileType: string = 'Select Customer Profile Type';
  public selectPaymentDetailsSchema: string = 'Select Payment Details Schema';
  public selectDocumentType: string = 'Select Document Type';
  public selectModeOfPayout: string = 'Select Mode Of Payout';
  public selectModeOfPayment: string = 'Select Mode Of Payment';
  public selectPaymentDetails: string = 'Select Payment Details';
  public selectRiskCalculator: string = 'Select Risk Calculator';
  public selectImplementationClass: string = 'Select Implementation Class';
  public selectImplName: string = 'Select Impl Name';
  public selectExpiryType: string = 'Select Expiry Type';
  public selectOwner: string = 'Select Owner';
  public selectOwnerName: string = 'Select Owner Name';
  public selectLogo: string = 'Select Logo';
  public selectBanner: string = 'Select Banner';
  public selectIcon: string = 'Select Icon';
  public selectOtpDeliveryChannel: string = 'Select OTP Delivery Channel';
  public selectTransactionColumns: string = 'Select Transaction Columns';
  public selectSenderCustomerColumns: string = 'Select Sender Customer Columns';
  public selectReceiverCustomerColumns: string = 'Select Receiver Customer Columns';
  public selectReceivingPartnerColumns: string = 'Select Receiving Partner Columns';
  public selectSendingPartnerColumns: string = 'Select Sending Partner Columns';
  public selectTemplates: string = 'Select Templates';

  public enterEmail: string = 'Enter Email';
  public enterName: string = 'Enter Name';
  public enterMobileNumber: string = 'Enter Mobile Number';
  public enterDescription: string = 'Enter Description';
  public enterCustomUrl: string = 'Enter Custom URL';
  public enterApplicationName: string = 'Enter Application Name';
  public enterHostedZone: string = 'Enter Hosted Zone';
  public enterFieldName: string = 'Enter Field Name';
  public enterFieldValue: string = 'Enter Field Value';
  public enterRateOfRequest: string = 'Enter Rate of Request';
  public enterRunIntervalValue: string = 'Enter Run Interval Value';
  public enterPassword: string = 'Enter Password';
  public enterNewPassword: string = 'Enter New Password';
  public enterCurrentPassword: string = 'Enter Current Password';
  public enterConmment: string = 'Enter Comment';
  public enterAmount: string = 'Enter Amount';
  public enterOccupation: string = 'Enter Occupation';
  public enterRiskScore: string = 'Enter Risk Score';
  public enterAge: string = 'Enter Age';
  public enterTemplateName: string = 'Enter Template Name';
  public enterValue: string = 'Enter Value';
  public enterSMTPServerHost: string = 'Enter SMTP Server Host';
  public enterSMTPServerPort: string = 'Enter SMTP Server Port';
  public enterSMTPUserName: string = 'Enter SMTP User Name';
  public enterSMTPPassword: string = 'Enter SMTP Password';
  public enterSMTPSenderEmail: string = 'Enter SMTP Sender Email';
  public enterFooterMessage: string = 'Enter Footer Message';
  public enterCF: string = 'Enter CF';
  public enterCFUrl: string = 'Enter CF Url';
  public enterFieldRegex: string = 'Enter Field Regex';
  public enterMask: string = 'Enter Mask';
  public enterFieldHint: string = 'Enter Field Hint';
  public enterFieldDescription: string = 'Enter Field Description';
  public enterExpiryAfterDays: string = 'Enter Expiry After Days';
  public enterAreaWghtOnCmplxFld: any = 'Enter Area Weight On Complex Field';
  public enterRepeatMinTimes: any = 'Enter Repeat Min Times';
  public enterSelectQuery: any = 'Enter Select Query';
  public enterSelectOptionValue: any = 'Enter Select Option Value';
  public enterSelectOptionDescription: any = 'Enter Select Option Description';
  public enterSupportEmail: string = 'Enter Support Email';
  public enterReason: string = 'Enter Reason';
  public enterRelationship: string = 'Enter Relationship';
  public enterNickName: string = 'Enter Nick Name';
  public enterLabel: string = 'Enter Label';

  public countryIsRequired: string = 'Country is required';
  public emailIsRequired: string = 'Email is required';
  public nameIsRequired: string = 'Name is required';
  public firstNameIsRequired: string = 'First Name is required';
  public lastNameIsRequired: string = 'Last Name is required';
  public passwordIsRequired: string = 'Password is required';
  public mobileNumberIsRequired: string = 'Mobile Number is required';
  public accessRoleIsRequired: string = 'Access Role is required';
  public accessControlsIsRequired: string = 'Access Controls is required';
  public descriptionIsRequired: string = 'Description is required';
  public adminIsRequired: string = 'Admin is required';
  public implClassIsRequired: string = 'Implementation Class is required';
  public partnerTypeIsRequired: string = 'Partner Type is required';
  public managedByIsRequired: string = 'Managed By is required';
  public createUnderAdminIsRequired: string = 'Create Under Admin is required';
  public riskCalculationUsageIsRequired: string = 'Risk Calculation Usage is required';
  public implementationClassIsRequired: string = 'Implementation Class is required';
  public riskScoreIsRequired: string = 'Risk Score is required';
  public riskGradeLevelIsRequired: string = 'Risk Grade Level is required';
  public riskGradeThresholdIsRequired: string = 'Risk Grade Threshold is required';
  public riskGradeHoldTransactionIsRequired: string = 'Risk Grade Hold Transaction is required';
  public riskGradePauseAccountIsRequired: string = 'Risk Grade Pause Account is required';
  public contactEmailIsRequired: string = 'Contact Email is required';
  public contactMobileNumberIsRequired: string = 'Contact Mobile Number is required';
  public otpDeliveryChannelIsRequired: string = 'OTP Delivery Channel is required';
  public customerProfileTypeIsRequired: string = 'Customer Profile Type is required';
  public customerIsRequired: string = 'Customer is required';
  public dateOfBirthIsRequired: string = 'Date Of Birth is required';
  public countryCodeFormobilenumberIsRequired: string = 'Country Code for mobile number is required';
  public modeOfPaymentOrPayoutIsRequired: any = 'Mode Of Payment Or Payout is required';
  public receiverProfileTypeIsRequired: string = 'Receiver Profile Type is required';
  public queueMasterStateIsRequired: string = 'Queue Master State is required';
  public updateTypeIsRequired: string = 'Update Type is required';
  public occupationIsRequired: string = 'Occupation is required';
  public ageIsRequired: string = 'Age is required';
  public templateNameIsRequired: string = 'Template Name is required';
  public lcFrequencyBoundCriteriaValueIsRequired: string = 'Liveness Check Frequency Bound Criteria Value is required';
  public smtpServerHostIsRequired: string = 'SMTP Server Host is required';
  public startTimeIsRequired: string = 'Start Time is required';
  public endTimeIsRequired: string = 'End Time is required';
  public fieldHintIsRequired: string = 'Field Hint is required';
  public repeatMinTimesIsRequired: string = 'Repeat Min Times is required';
  public cmplxFldOrientationIsRequired: any = 'Complex Field Orientation is required';
  public selectQueryIsRequired: any = 'Select Query is required';
  public selectOptionValueIsRequired: any = 'Select Option Value is required';
  public selectOptionDescriptionIsRequired: any = 'Select Option Description is required';
  public smtpUserNameIsRequired: string = 'SMTP User Name is required';
  public reasonIsRequired: string = 'Reason is required';
  public relationshipIsRequired: string = 'Relationship is required';
  public clientPlatformIsRequired: string = 'Client Platform is required';
  public timeoutIsRequired: string = 'Timeout is required';
  public transactionEstimateTimeoutIsRequired: string = 'Transaction Estimate Timeout is required'
  public paymentDetailsSchemaIsRequired: string = 'Payment Details Schema is required';
  public nickNameIsRequired: string = 'Nick Name is required';
  public labelIsRequired: string = 'Label is required';
  public sendingCountriesIsRequired: any = 'Sending Countries is required';
  public receivingCountriesIsRequired: any = 'Receiving Countries is required';
  public sendingCurrenciesIsRequired: any = 'Sending Currencies is required';
  public receivingCurrenciesIsRequired: any = 'Receiving Currencies is required';
  public currencyIsRequired: any = 'Currency is required';
  public amountIsRequired: any = 'Amount is required';
  public timeframeIsRequired: any = 'Time Frame is required';
  public timeUnitIsRequired: any = 'Time Unit is required';
  public commentIsRequired: any = 'Comment is required';
  public transactionCountLimitIsRequired: any = 'Transaction Count Limit is required';
  public expiryTypeIsRequired: any = 'Expiry Type is required';
  public fromCurrencyIsRequired: any = 'From Currency is required';
  public toCurrencyIsRequired: any = 'To Currency is required';
  public runIntervalUnitIsRequired: string = 'Run interval Unit is required';
  public runIntervalValueIsRequired: string = 'Run Interval Value is required';
  public rateofRequestIsRequired: string = 'Rate of Request is required';
  public ownerNameIsRequired: string = 'Owner Name is required';
  public notificationBannerTypeIsRequired: any = 'Notification Banner Type is required';
  public notificationBannerDestinationIsRequired: any = 'Notification Banner Destination is required';
  public partnerProcessorImplIsRequired: any = 'Partner Processor Impl is required';
  public riskCalculatorIsRequired: any = 'Risk Calculator is required';
  public riskFactorIsRequired: any = 'Risk Factor is required';
  public oneAmongContributedRiskScoreOrWeightFieldsIsRequired: string = 'One among Contributed Risk Score or Weight fields is required';
  public onlyOneOfContributedRiskScoreOrWeightFieldsIsRequired: string = 'Only one of Contributed Risk Score or Weight fields is required';
  public userTypeIsRequired: any = 'User Type is required';
  public userIsRequired: any = 'user is required';
  private englishDict: Record<string, string> = {};

  private frenchDict: Record<string, string> = {
    email: 'E-mail',
    country: 'Pays',
    countryMobileNo: 'Code pays',
    mobileNumber: 'Numéro de mobile',
    grabberName: 'Nom du capteur',
    name: 'Nom',
    adminId: 'ID administrateur',
    customer: 'Client',
    addCustomer: 'Ajouter un client',
    createCustomer: 'Créer un client',
    receiver: 'Destinataire',
    addReceiver: 'Ajouter un destinataire',
    createReceiver: 'Créer un destinataire',
    viewReceiver: 'Voir le destinataire',
    countryOfficialName: 'Nom officiel du pays',
    countryAlpha2: 'Alpha-2 du pays',
    countryAlpha3: 'Alpha-3 du pays',
    code: 'Code',
    affiliatePartner: 'Partenaire affilié',
    city: 'Ville',
    pincode: 'Code postal',
    accessRole: "Rôle d'accès",
    password: 'Mot de passe',
    newPassword: 'Nouveau mot de passe',
    currentPassword: 'Mot de passe actuel',
    changePassword: 'Changer le mot de passe',
    forgotPassword: 'Mot de passe oublié',
    authenticationApps: "Applications d'authentification",
    twoFactorLabel: 'Double facteur',
    twoFactorAuth: 'Authentification à deux facteurs',
    verify: 'Vérifier',
    mobileAndEmailVerification: 'Vérification mobile et e-mail',
    otpDeliveryChannel: 'Canal de livraison OTP',
    enableTwoFactorAuth: "Activer l'authentification à deux facteurs",
    enableTrustedDeviceCheck: 'Activer la vérification des appareils de confiance',
    trustedDeviceCheck: 'Vérification des appareils de confiance',
    enableLiteMode: 'Activer le mode lite',
    approverLevel: "Niveau d'approbateur",
    riskGradeConfig: 'Configuration des grades de risque',
    description: 'Description',
    documentCategories: 'Catégories de documents',
    stakeHolderDocumentCategory: 'Catégorie de document des parties prenantes',
    actionAfterExpiry: "Action après l'expiration",
    expiryWarningBufferDays: "Jours de tampon d'avertissement d'expiration",
    expirable: 'Expirable',
    categoryName: 'Nom de catégorie',
    stakeHoldersIdText: 'Parties prenantes',
    serviceable: 'Utilisable',
    businessStakeHoldersId: 'Identifiant des parties prenantes / UBOs',
    otpSender: 'Implémentation de l\'envoi OTP',
    addressSchema: "Schéma d'adresse",
    address: 'Adresse',
    createdDate: 'Date de création',
    businessIdentificationFieldSchema: "Schéma de champ d'identification commerciale",
    individualIdentifierFieldSchema: "Schéma de champ d'identification individuelle",
    adminFieldSchema: "Schéma de champ administrateur",
    partnerFieldSchema: 'Schéma de champ partenaire',
    customerFieldSchema: 'Schéma de champ client',
    paymentDetailsFieldSchema: 'Schéma de champ des détails de paiement',
    partnerProcessorImpl: 'Implémentation du processeur partenaire',
    adminKyc: 'KYC administrateur',
    partnerKyc: 'KYC partenaire',
    customerKyc: 'KYC client',
    affiliatePartnerKyc: 'KYC partenaire affilié',
    riskScoreForAdmins: 'Score de risque du pays pour les administrateurs',
    riskScore: 'Score de risque',
    docsIncompleteRiskScore: 'Score de risque docs incomplets',
    livenessIncompleteRiskScore: 'Score de risque liveness incomplet',
    amlIncompleteRiskScore: 'Score de risque AML incomplet',
    amsIncompleteRiskScore: 'Score de risque AMS incomplet',
    pepIncompleteRiskScore: 'Score de risque PEP incomplet',
    mandatory: 'Obligatoire',
    fieldName: 'Nom du champ',
    fieldType: 'Type de champ',
    fieldRegex: 'Regex du champ',
    order: 'Ordre',
    fieldDescription: 'Description du champ',
    fieldHint: 'Indice du champ',
    hint: 'Indice',
    selectOptions: 'Options de sélection',
    selectOptionValue: "Valeur de l'option de sélection",
    selectOptionDescription: "Description de l'option de sélection",
    hasToBeUnique: 'Doit être unique',
    postalCode: 'Code postal',
    cityOrTown: 'Ville ou commune',
    fieldSchemaFieldSelectOptionType: 'Type d\'option de sélection du schéma de champ',
    cmplxFldOrientation: 'Orientation du champ complexe',
    mask: 'Masque',
    selectQuery: 'Requête de sélection',
    areaWghtOnCmplxFld: 'Poids de zone sur le champ complexe',
    repeatMinTimes: 'Répéter min fois',
    expiryAfterDays: 'Expiration après jours',
    expiryDateField: "Date d'expiration",
    toDate: 'À la date',
    fromDate: 'De la date',
    effectiveFromDate: "Date d'effet de",
    date: 'Date',
    queryString: 'Recherche',
    searchPartner: 'Rechercher un partenaire',
    expiryType: "Type d'expiration",
    partnerType: 'Type de partenaire',
    managedBy: 'Géré par',
    createUnderAdmin: "Créer sous l'administrateur",
    status: 'Statut',
    accountStatus: 'Statut du compte',
    updateUserAccountStatus: 'Mettre à jour le statut du compte utilisateur',
    customerProfileType: 'Type de profil client',
    adminUser: 'Utilisateur administrateur',
    weight: 'Poids',
    fromCurrency: 'De la devise',
    toCurrency: 'Vers la devise',
    Currency: 'Devise',
    currencyCode: 'Code de devise',
    documentStatus: 'Statut du document',
    userType: "Type d'utilisateur",
    user: 'Utilisateur',
    documentCategory: 'Catégorie de document',
    totalDocumentCategory: 'Total des catégories de documents',
    totalFieldSchema: 'Total des schémas de champs',
    dateRangeType: 'Type de plage de dates',
    comment: 'Commentaire',
    resendOtp: 'Renvoyer l\'OTP dans',
    alreadyHaveAnOtp: 'Vous avez déjà un OTP',
    sendOtp: 'Envoyer OTP',
    resendbtn: 'Renvoyer',
    buttonLogout: 'Déconnexion',
    donebtn: 'Terminé',
    submitBtn: 'Soumettre',
    updateBtn: 'Mettre à jour',
    action: 'Action',
    actions: 'Actions',
    filterbtn: 'Filtrer',
    applyFilters: 'Appliquer les filtres',
    accessControl: "Contrôle d'accès",
    accessControls: "Contrôles d'accès",
    method: 'Méthode',
    httpMethod: 'Méthode HTTP',
    adminCode: 'Code administrateur',
    implClass: "Classe d'implémentation",
    implClassName: "Nom de la classe IMPL",
    currencies: 'Devises',
    sendingCurrencies: "Devises d'envoi",
    receivingCurrencies: 'Devises de réception',
    countries: 'Pays',
    sendingCountries: "Pays d'envoi",
    receivingCountries: 'Pays de réception',
    modeOfPayment: 'Mode de paiement',
    modeOfPaymentOrPayout: 'Mode de paiement ou de versement',
    reqPerMinute: 'Requêtes par minute',
    partialRefundAllowed: 'Remboursement partiel autorisé',
    perTransactionValLimitRequest: 'Demande de limite de valeur par transaction',
    admin: 'Administrateur',
    addAdmin: 'Ajouter un administrateur',
    isActiveRequired: 'Est actif requis',
    paymentInstrumentCode: "Code de l'instrument de paiement",
    relationship: 'Relation',
    addRelationship: 'Ajouter une relation',
    sendingPartnerName: "Nom du partenaire d'envoi",
    sendingPartnerCode: "Code du partenaire d'envoi",
    apiKeyUsed: 'Clé API utilisée',
    tokenTire: 'Niveau de token',
    successful: 'Réussi',
    api: 'API',
    partner: 'Partenaire',
    addPartner: 'Ajouter un partenaire',
    paymentInstrument: 'Instrument de paiement',
    addPaymentInstrument: "Ajouter un instrument de paiement",
    amount: 'Montant',
    type: 'Type',
    emailsToNotify: 'E-mails à notifier',
    notifyAllUser: 'Notifier tous les utilisateurs',
    notifyViaEmail: 'Notifier par e-mail',
    notifyViaNotification: 'Notifier par notification',
    userTargetedNotification: 'Notification ciblée utilisateur',
    notifyViaEmailIfNotReadWithInMinutes: 'Notifier par e-mail si non lu en minutes',
    propagateReadStatusAcrossRelatedNotification: 'Propager le statut de lecture aux notifications liées',
    propagateNotificationToUpperLevelIfNotRead: 'Propager la notification au niveau supérieur si non lu',
    thresholdMinutesToReadNotification: 'Minutes seuil pour lire la notification',
    notificationBannerType: 'Type de bannière de notification',
    notificationBannerDestination: 'Destination de la bannière de notification',
    thresholdDaysToTransformToBanner: 'Jours seuil pour transformer en bannière',
    PaymentDetailsSchema: 'Schéma des détails de paiement',
    addMorePaymentDetailsSchema: 'Ajouter plus de valeurs au schéma des détails de paiement',
    label: 'Étiquette',
    profile: 'Profil',
    profileType: 'Type de profil',
    livenessAndSanctionCheckSettings: 'Paramètres de vérification de présence et de sanction',
    livenessSanctionCheckAdmin: 'Vérification de présence et de sanction - Administrateur',
    livenessSanctionCheckPartner: 'Vérification de présence et de sanction - Partenaire',
    livenessSanctionCheckCustomer: 'Vérification de présence et de sanction - Client',
    updateTheme: 'Mettre à jour le thème',
    lcTimeBoundCriteria: 'Critère temporel de vérification de présence',
    lcTimeBoundCriteriaUnit: 'Unité du critère temporel LC',
    lcTimeBoundCriteriaValue: 'Valeur du critère temporel LC',
    lcFrequencyBoundCriteria: 'Critère de fréquence LC',
    lcFrequencyBoundCriteriaValue: 'Valeur du critère de fréquence LC',
    scTimeBoundCriteria: 'Critère temporel de vérification de sanction',
    scTimeBoundCriteriaUnit: 'Unité du critère temporel SC',
    scTimeBoundCriteriaValue: 'Valeur du critère temporel SC',
    scTimeBoundCriteriaValueType: 'Type de valeur du critère temporel SC',
    scFrequencyBoundCriteria: 'Critère de fréquence SC',
    scFrequencyBoundCriteriaValue: 'Valeur du critère de fréquence SC',
    scFrequencyBoundCriteriaValueType: 'Type de valeur du critère de fréquence SC',
    liveness: 'Présence',
    livenessCheck: 'Vérification de présence',
    sanction: 'Sanction',
    sanctionCheck: 'Vérification de sanction',
    weekScheduleForPartner: 'Planning hebdomadaire',
    riskGrade: 'Grade de risque',
    riskGradeLevel: 'Niveau',
    riskGradeSeverity: 'Sévérité',
    riskGradeThreshold: 'Seuil (%)',
    riskGradeHoldTransaction: 'Bloquer la transaction',
    riskGradePauseAccount: 'Suspendre le compte',
    riskGradeApprovalOptions: "Options d'approbation",
    iSar: 'I-SAR',
    sarCreatedDate: 'Date de création',
    sarTransactionCode: 'Code de transaction',
    sarExplanation: 'Explication',
    updateSmtp: 'Mettre à jour la configuration SMTP',
    smtpConfiguration: 'Configuration SMTP',
    smtpServerHost: 'Hôte du serveur SMTP',
    smtpServerPort: 'Port du serveur SMTP',
    smtpUserName: "Nom d'utilisateur SMTP",
    smtpPassword: 'Mot de passe SMTP',
    smtpSenderEmail: 'E-mail expéditeur SMTP',
    smtpAuthEnabled: 'Auth SMTP activé',
    smtpSSLEnabled: 'SSL SMTP activé',
    smtpStartTlsEnabled: 'Start TLS SMTP activé',
    receiverProfileType: 'Type de profil destinataire',
    paymentMethod: 'Méthode de paiement',
    payoutMethod: 'Méthode de versement',
    usedMyPayoutMethod: 'Utiliser ma méthode de paiement',
    changePasswordWithRemitall: 'Changer le mot de passe avec RemitAll',
    isRequired: 'est requis',
    enter: 'Saisir',
    resetPasswordWithRemitAll: 'Réinitialiser le mot de passe avec RemitAll',
    signinToContinue: 'Connectez-vous pour continuer',
    validEmailAddress: "L'e-mail doit être une adresse valide",
    login: 'Se connecter',
    notHaveAnAccount: "Vous n'avez pas de compte ?",
    signupNow: "S'inscrire maintenant",
    supportEmail: 'E-mail de support',
    subUser: 'Sous-utilisateur',
    addSubUser: 'Ajouter un sous-utilisateur',
    verifyYourEmail: 'Vérifiez votre e-mail',
    confirm: 'Confirmer',
    signUpToContinue: "Inscrivez-vous pour continuer",
    select: 'Sélectionner',
    firstName: 'Prénom',
    optional: '(Facultatif)',
    middleName: 'Deuxième prénom',
    lastName: 'Nom de famille',
    dateOfBirth: 'Date de naissance',
    countryCodeFormobilenumber: 'Indicatif pays pour mobile',
    passwordMinimumLength: 'Le mot de passe doit contenir au moins 6 caractères',
    passwordUpperCaseLetter: 'Le mot de passe doit contenir au moins 1 lettre majuscule',
    passwordLowerCaseLetter: 'Le mot de passe doit contenir au moins 1 lettre minuscule',
    passwordSpecialCharacter: 'Le mot de passe doit contenir au moins 1 caractère spécial',
    passwordContainANumber: 'Le mot de passe doit contenir un chiffre',
    signUp: "S'inscrire",
    save: 'Enregistrer',
    saveAddress: "Enregistrer l'adresse",
    saveIndividualIdentifier: "Enregistrer l'identifiant individuel",
    saveMiscellaneousFields: 'Enregistrer les champs divers',
    saveBusinessDetails: "Enregistrer les détails commerciaux",
    stepVerification: 'Vérification en 2 étapes',
    timeBasedOtpMobiile: 'OTP temporel depuis votre mobile',
    emailOtp: 'OTP sur votre e-mail',
    second: 'secondes',
    setup: 'Configuration',
    otp: 'OTP',
    sendMoney: "Envoyer de l'argent",
    settings: 'Paramètres',
    overview: 'Aperçu',
    add: 'Ajouter',
    addNew: 'Ajouter nouveau',
    addMore: 'Ajouter plus',
    edit: 'Modifier',
    close: 'Fermer',
    fieldSelectOption: 'Option de sélection de champ',
    complexFeild: 'Champ complexe',
    repeat: 'Répéter',
    identifier: 'Identifiant',
    individualIdentifier: 'Identifiant individuel',
    timeBoundCriteria: 'Critères temporels LC',
    freqBoundCriteria: 'Critères de fréquence LC',
    scTimeBoundCriteria2: 'Critères temporels SC',
    scFrequencyBoundCriteria2: 'Critères de fréquence SC',
    lcUpdateTimeBoundCriteria: 'Mettre à jour critère temporel LC',
    lcUpdateFreqBoundCriteria: 'Mettre à jour critère de fréquence LC',
    scUpdateTimeBoundCriteria: 'Mettre à jour critère temporel SC',
    scUpdateFreqBoundCriteria: 'Mettre à jour critère de fréquence SC',
    scTimeBoundCriteriaTimeUnitValue: 'Valeur unité de temps du critère temporel SC',
    scTimeBoundCriteriaTimeUnit: 'Unité de temps du critère temporel SC',
    lcTimeFreqCriteriaValueLimit: 'Limite valeur critère temps/fréquence LC',
    lcFreqBoundCriteriaValueLimit: 'Limite valeur critère fréquence LC',
    scFreqBoundCriteriaValueLimit: 'Limite valeur critère fréquence SC',
    scFreqBoundCriteriaValueType: 'Type valeur critère fréquence SC',
    repeatChild: 'Répéter enfant',
    makeNonMandatory: 'Rendre non obligatoire',
    kyc: 'KYC',
    requiredMessage: 'Ceci est requis',
    fieldSchema: 'Schéma de champ',
    minimumValue: 'La valeur minimale pour ce champ est 0',
    maximumValue10: 'La valeur maximale pour ce champ est 10',
    maximumValue: 'La valeur maximale pour ce champ est 100',
    greaterThan100: 'La valeur du score de risque est supérieure à 100',
    documents: 'Documents',
    viewDocument: 'Voir le document',
    uploadDocuments: 'Télécharger des documents',
    attachDocuments: 'Joindre des documents',
    cancel: 'Annuler',
    limit: 'Limite',
    available: 'disponible',
    repayment: 'Remboursement',
    transactions: 'Transactions',
    updateLimit: 'Mettre à jour la limite',
    increaseLimit: 'Augmenter la limite',
    decreaseLimit: 'Diminuer la limite',
    updateCreditLinePayment: 'Mettre à jour le paiement de la ligne de crédit',
    paused: 'En pause',
    active: 'Actif',
    updateQueueMasterState: "Mettre à jour l'état de la file d'attente",
    queueMasterState: "État de la file d'attente principale",
    refreshInterval: 'Intervalle de rafraîchissement',
    selectDateRange: 'Sélectionner la plage de dates',
    data: 'Données',
    create: 'Créer',
    clicktoCopy: 'Cliquer pour copier',
    share: 'Partager',
    open: 'Ouvrir',
    updateType: 'Type de mise à jour',
    global: 'Global',
    individual: 'Individuel',
    updateForAllAdminUsers: 'Mettre à jour pour tous les administrateurs',
    reset: 'Réinitialiser',
    updateAllCustomer: 'Mettre à jour pour tous les clients',
    customerUser: 'Utilisateur client',
    updatePartnerUser: 'Mettre à jour pour tous les partenaires',
    partnerUser: 'Utilisateur partenaire',
    impersonationOtp: 'OTP d\'emprunt d\'identité',
    pleaseContacttheParentUser: "Veuillez contacter l'utilisateur parent pour plus de détails",
    businessDetails: 'Détails commerciaux',
    miscellaneousFields: 'Champs divers',
    businessIndentifier: 'Identifiant commercial',
    individualIndentifier: 'Identifiant individuel',
    adminCustomerRiskParams: 'Paramètres de risque client admin',
    riskParams: 'Paramètres de risque',
    occupation: 'Profession',
    addOccupation: 'Ajouter une profession',
    occupationList: 'Liste des professions',
    editOccupationRiskScore: 'Modifier le score de risque de profession',
    ageRangeBracket: "Tranche d'âge",
    ageRangeBracketList: "Liste des tranches d'âge (borne inférieure)",
    age: 'Âge',
    addAgeRangeBracket: "Ajouter une tranche d'âge",
    editAgeRangeBracket: "Modifier la tranche d'âge",
    clientPlatform: 'Plateforme client',
    platform: 'Plateforme',
    twoFactorNotRequiredTimeout: 'Délai sans double authentification (en ms)',
    transactionEstimateTimeout: "Délai d'estimation de transaction (en ms)",
    transactionReportTemplates: 'Modèles de rapport de transaction',
    transactionColumns: 'Colonnes de transaction',
    noTransactionColumns: 'Aucune colonne de transaction sélectionnée',
    senderCustomerColumns: 'Colonnes client expéditeur',
    noSenderCustomerColumns: 'Aucune colonne client expéditeur sélectionnée',
    receiverCustomerColumns: 'Colonnes client destinataire',
    noReceiverCustomerColumns: 'Aucune colonne client destinataire sélectionnée',
    senderPartnerColumns: 'Colonnes partenaire expéditeur',
    noSenderPartnerColumns: 'Aucune colonne partenaire expéditeur sélectionnée',
    receiverPartnerColumns: 'Colonnes partenaire destinataire',
    noReceiverPartnerColumns: 'Aucune colonne partenaire destinataire sélectionnée',
    sendingPartnerColumns: "Colonnes partenaire d'envoi",
    receivingPartnerColumns: 'Colonnes partenaire de réception',
    emailReportConfiguration: 'Configuration des rapports e-mail',
    reconciliationToEmail: 'Réconciliation - À',
    enterValidEmail: 'Veuillez entrer un e-mail valide',
    reconciliationCCEmails: 'Réconciliation - CC',
    emailEnterMessage: "Pour insérer plusieurs e-mails, appuyez sur ENTRÉE après chaque saisie",
    accountManagerToEmail: 'Gestionnaire de compte - À',
    accountManagerCCEmails: 'Gestionnaire de compte - CC',
    managementToEmail: 'Direction - À',
    managementCCEmails: 'Direction - CC',
    weeklyReportToEmail: 'Rapport hebdomadaire - À',
    weeklyReportCCEmails: 'Rapport hebdomadaire - CC',
    templates: 'Modèles',
    templateName: 'Nom du modèle',
    arrangeColumns: 'Organiser les colonnes',
    preview: 'Aperçu',
    paidTxns: 'Txns payées',
    processingTxns: 'Txns en cours',
    paidAmount: 'Montant payé',
    charges: 'Frais',
    refundCharge: 'Frais de remboursement',
    loading: 'Chargement',
    sending: 'Envoi',
    receiving: 'Réception',
    modeOfPayout: 'Mode de versement',
    chargeExclusive: 'Frais exclusifs',
    chargeInclusive: 'Frais inclusifs',
    recipientGets: 'Le destinataire reçoit',
    toSend: 'À envoyer',
    totaltoPay: 'Total à payer',
    payingWith: 'Payer avec',
    change: 'Modifier',
    receiverDetails: 'Détails du destinataire',
    receiverName: 'Nom du destinataire',
    receiverCode: 'Code du destinataire',
    paymentDetails: 'Détails de paiement',
    paymentMode: 'Mode de paiement',
    addPaymentDetails: 'Veuillez ajouter les détails de paiement pour le destinataire',
    purpose: 'Objet',
    totalCharge: 'Frais total',
    createdbyme: 'Créé par moi',
    sent: 'Envoyé',
    exchangeRate: 'Taux de change',
    sendingPartner: "Partenaire d'envoi",
    receivingPartner: 'Partenaire de réception',
    sender: 'Expéditeur',
    receipt: 'Reçu',
    printReceipt: 'Imprimer le reçu',
    initiateReturn: 'Initier le retour',
    checkLiveness: 'Vérifier la présence',
    skipLiveness: 'Ignorer la présence',
    initiatePayment: 'Initier le paiement',
    paymentDone: 'Paiement effectué',
    payoutStart: 'Début du versement',
    payoutDone: 'Versement effectué',
    overrideSARRisk: 'Remplacer le risque SAR',
    overrideKyc: 'Remplacer KYC',
    overrideLiveness: 'Remplacer la présence',
    overrideSanction: 'Remplacer la sanction',
    completeReturn: 'Compléter le retour',
    markasReturnFailed: 'Marquer comme retour échoué',
    rejectReturn: 'Rejeter le retour',
    senderDetails: "Détails de l'expéditeur",
    payoutDetails: 'Détails du versement',
    transactionBreakdown: 'Décomposition de la transaction',
    amountSent: 'Montant envoyé',
    amountReceived: 'Montant reçu',
    totalCharged: 'Total facturé',
    verifications: 'Vérifications',
    approveRiskCheck: 'Approuver la vérification des risques',
    canBeApprovedBy: 'Peut être approuvé par',
    resolved: 'Résolu',
    message: 'Message',
    reason: 'Raison',
    addReason: 'Ajouter une raison',
    skipLivenessCheck: 'Ignorer la vérification de présence',
    reasonForSkippingLivenessCheck: 'Veuillez fournir une raison pour ignorer la vérification de présence',
    noReasonsFoundForAdmin: "Aucune raison trouvée pour l'administrateur",
    dropFilesHereOrClickToUpload: 'Déposez les fichiers ici ou cliquez pour télécharger',
    maximumFileSize: 'Taille de fichier maximale :',
    sendFile: 'Envoyer le fichier',
    createTransaction: 'Créer une transaction',
    documentName: 'Nom du document',
    state: 'État',
    createNewTransaction: 'Créer une nouvelle transaction',
    downloadTransactionReport: 'Télécharger le rapport de transaction',
    selectFileFormat: 'Sélectionner le format de fichier',
    exportViaEmail: 'Rapport trop volumineux, veuillez exporter par e-mail.',
    sendReportToMyEmail: 'Envoyer le rapport à mon e-mail',
    downloadAutomatically: 'Votre téléchargement devrait démarrer automatiquement. Sinon, vous pouvez',
    downloadItHere: 'le télécharger ici.',
    upload: 'Télécharger',
    fileType: 'Type de fichier',
    viewDocumentDetails: 'Voir les détails du document',
    document: 'Document',
    documentType: 'Type de document',
    documentNumber: 'Numéro du document',
    documentDetails: 'Détails du document',
    viewLivenessAndSanctionCheckSetting: 'Voir les paramètres de vérification de présence et de sanction',
    pleaseEntervalidSMTPServerHost: 'Veuillez entrer un hôte SMTP valide',
    enterValidSMTPServerPort: 'Veuillez entrer un port SMTP valide',
    entervalidUserName: "Veuillez entrer un nom d'utilisateur valide",
    entervalidPassword: 'Veuillez entrer un mot de passe valide',
    smtpAuthEnabledRequired: 'Auth SMTP activé est requis',
    smtpSSLEnabledRequired: 'SSL SMTP activé est requis',
    smtpStartTLSEnabledRequired: 'Start TLS SMTP activé est requis',
    themeColorPrimary: 'Couleur principale du thème',
    usingFormatOption: "Utilisation de l'option de format",
    themeColorSecondary: 'Couleur secondaire du thème',
    customUrl: 'URL personnalisée',
    enterValidCustomUrl: 'Veuillez entrer une URL personnalisée valide',
    applicationName: "Nom de l'application",
    footerMessage: 'Message de pied de page',
    logo: 'Logo',
    icon: 'Icône',
    banner: 'Bannière',
    recommendedDimensions: 'Dimensions recommandées',
    pixels: 'pixels',
    only: 'Seulement',
    pngImagesAllowed: 'Seules les images PNG sont autorisées',
    send: 'Envoyer',
    cf: 'CF',
    cFUrl: 'URL CF',
    hostedZone: 'Zone hébergée',
    viewWeeklySchedule: 'Voir le planning hebdomadaire',
    selectDay: 'Sélectionner le jour',
    startTime: 'Heure de début',
    endTime: 'Heure de fin',
    weeklySchedule: 'Planning hebdomadaire',
    selectFirstExceptionschedule: "Veuillez d'abord sélectionner un partenaire pour ajouter une exception",
    viewExceptionSchedule: "Voir le planning d'exception",
    addNewExceptionSchedule: "Ajouter un nouveau planning d'exception",
    delete: 'Supprimer',
    innerCharges: 'Frais internes',
    maxCumulativeValue: 'Valeur cumulative maximale',
    slabs: 'Tranches',
    updateCharge: 'Mettre à jour les frais',
    visibilityLevel: 'Niveau de visibilité',
    chargeName: 'Nom des frais',
    fromAmount: 'Du montant',
    toAmount: 'Au montant',
    flat: 'Fixe',
    percentage: 'Pourcentage',
    typeRequired: 'Le type est requis',
    maxLength100: 'La longueur maximale est 100',
    fieldSchemaSelectTypeRequired: "Le type d'option de sélection du schéma de champ est requis",
    addmoreFieldSchema: 'Ajouter plus de schémas de champs',
    addField: 'Ajouter un champ',
    fieldValue: 'Valeur du champ',
    qualifier: 'Qualificateur',
    preferredPartner: 'Partenaire préféré',
    modesOfPayment: 'Modes de paiement',
    modesOfPayout: 'Modes de versement',
    effectiveToDate: "Date d'effet jusqu'à",
    pertransactionValueLimit: 'Limite de valeur par transaction',
    transactionCountLimit: 'Limite du nombre de transactions',
    timeFrameValue: 'Valeur du cadre temporel',
    timeFrameUnit: 'Unité du cadre temporel',
    timeFrame: 'Cadre temporel',
    transactionValueLimit: 'Limite de valeur de transaction',
    timeUnit: 'Unité de temps',
    timeUnitValue: 'Valeur de l\'unité de temps',
    fxMargin: 'Marge FX',
    absoluteRate: 'Taux absolu',
    rate: 'Taux',
    rateStrategy: 'Stratégie de taux',
    dynamicMargin: 'Marge dynamique',
    staticFxRate: 'Taux FX statique',
    refundStrategy: 'Stratégie de remboursement',
    transactionProcessStrategy: 'Stratégie de traitement des transactions',
    paymentProviderInstrument: 'Instrument du fournisseur de paiement',
    commission: 'Commission',
    updateQualifier: 'Mettre à jour le qualificateur',
    contactDetails: 'Coordonnées',
    contactEmail: 'E-mail de contact',
    contactMobileNumber: 'Numéro de mobile de contact',
    purposeList: 'Liste des objets',
    profileStatus: 'Statut du profil',
    updateUserApproverLevel: "Mettre à jour le niveau d'approbateur",
    timeout: 'Délai',
    mobileNumberIsInvalid: 'Le numéro de mobile est invalide',
    information: 'Information',
    individualUBO: 'UBO(s) individuels',
    nickName: 'Surnom',
    changeReceiverProfileType: 'Changer le type de profil destinataire',
    ownerCustomerEmail: "E-mail du client propriétaire",
    ownerCustomerCountry: 'Pays du client propriétaire',
    ownerCustomerName: 'Nom du client propriétaire',
    digits: 'Chiffres',
    closeViewDetails: 'Fermer et voir les détails',
    UltimateBeneficialOwnerDetails: 'Détails UBO (Bénéficiaire effectif ultime)',
    viewReceivers: 'Voir les destinataires',
    viewAdditionalDetails: 'Voir les détails supplémentaires',
    signedUpFromPartnerSide: 'Inscrit depuis le côté partenaire ?',
    partnerCode: 'Code partenaire',
    transactionList: 'Liste des transactions',
    transactionAmountLimitPerTransaction: 'Limite du montant de transaction par transaction',
    transactionAmountLimit: 'Limite du montant de transaction',
    transactionFrequencyLimit: 'Limite de fréquence de transaction',
    showAll: 'Tout afficher',
    showLatest: 'Afficher les derniers',
    profileRisk: 'Risque du profil',
    riskOverride: 'Remplacement du risque',
    profileRiskCheckFor: 'Vérification du risque du profil pour',
    createLiveness: 'Créer une présence',
    updateRiskParams: 'Mettre à jour les paramètres de risque',
    timeframe: 'Période',
    back: 'Retour',
    documentCategorySuggestion: 'Suggestion de catégorie de document',
    approvedOrRejectedBy: 'Approuvé ou rejeté par',
    view: 'Voir',
    download: 'Télécharger',
    selectIMPLName: "Sélectionner le nom IMPL",
    implNamerequired: 'Le nom IMPL est requis',
    runIntervalUnit: "Unité d'intervalle d'exécution",
    rateofRequestPerMinute: 'Taux de requête par minute',
    requestPerMinute: 'Requête par minute',
    rateofRequest: 'Taux de requête',
    ownerName: 'Nom du propriétaire',
    implName: 'Nom IMPL',
    runIntervalValue: "Valeur de l'intervalle d'exécution",
    addForexGrabber: 'Ajouter un capteur forex',
    intervalUnit: "Unité d'intervalle",
    intervalValue: "Valeur d'intervalle",
    requiredCurrencyPairs: 'Paires de devises requises',
    addForex: 'Ajouter un forex',
    effectiveFrom: 'Effectif à partir de',
    effectiveTo: "Effectif jusqu'à",
    pair: 'Paire',
    value: 'Valeur',
    addNotification: 'Ajouter une notification',
    pressEnterToAddMultipleEmail: "Pour insérer plusieurs e-mails, appuyez sur ENTRÉE",
    selectProcessorImpl: "Sélectionner l'impl du processeur",
    businessIdentifier: 'Identifiant commercial',
    capabilities: 'Capacités',
    sendingCapabilities: "Capacités d'envoi",
    receivingCapabilities: 'Capacités de réception',
    timeBoundCriteria2: 'Critère temporel',
    frequencyBoundCriteria: 'Critère de fréquence',
    day: 'Jour',
    startHour: 'Heure de début',
    startMin: 'Minute de début',
    endHour: 'Heure de fin',
    endMin: 'Minute de fin',
    exceptionSchedule: "Planning d'exception",
    noExceptionScheduleExistsuser: "Aucun planning d'exception pour cet utilisateur",
    addCapabilitiesQualifier: 'Ajouter un qualificateur de capacités',
    capabilityType: 'Type de capacité',
    riskCalculator: 'Calculateur de risque',
    addRiskCalculator: 'Ajouter un calculateur de risque',
    addRiskImplementation: 'Implémentation du risque',
    riskFactor: 'Facteur de risque',
    addRiskFactor: 'Ajouter un facteur de risque',
    riskName: 'Nom du risque',
    contributionRisk: 'Risque de contribution %',
    oneAmongContributedRiskScoreOrWeightFields: "L'un des champs de score de risque ou de poids contribués",
    onlyOneOfContributedRiskScoreOrWeightFields: "Un seul des champs de score de risque ou de poids",
    attachToAdminForCustomer: 'Attacher à Admin pour Client',
    riskCalculatorsLinkedToUserProfiles: 'Calculateurs de risque liés aux profils utilisateurs',
    riskCalculatorsApplicableForCustomers: 'Calculateurs de risque applicables aux clients',
    riskImplementation: 'Implémentation du risque',
    attachExistingRiskCalculator: 'Attacher un calculateur de risque existant',
    riskScoreEvaluation: 'Évaluation du score de risque',
    validityTime: 'Durée de validité',
    calculatorCode: 'Code du calculateur',
    factorCode: 'Code du facteur',
    contributedRiskScore: 'Score de risque contribué',
    attachedRiskFactorImplementation: "Voir l'implémentation du facteur de risque attaché",
    riskFactorImplementation: 'Implémentation du facteur de risque',
    addRiskFactorImplementation: "Ajouter l'implémentation du facteur de risque",
    editRiskFactorImplementation: "Modifier l'implémentation du facteur de risque",
    updateRiskFactorImplementationClass: "Mettre à jour la classe d'implémentation du facteur de risque",
    addRiskGradeApprovalOptions: "Ajouter les options d'approbation du grade de risque",
    updateRiskGradeApprovalOptions: "Mettre à jour les options d'approbation du grade de risque",
    valid: 'Valide',
    errorMessage: "Message d'erreur",
    dynamicVariables: 'Variables dynamiques',
    useForCustomerRiskCalculation: 'Utiliser pour le calcul du risque client ?',
    riskCalculationUsage: 'Utilisation du calcul du risque',
    yes: 'Oui',
    no: 'Non',
    implementationClass: "Classe d'implémentation",
    params: 'Paramètres',
    paramsEnterMessage: "Pour insérer plusieurs paramètres, appuyez sur ENTRÉE",
    customerLevelRiskCalculationsApplicable: 'Calculs de risque au niveau client applicables',
    optionNo: 'Option N°',
    level1Officer: 'Officier de niveau 1',
    level2Officer: 'Officier de niveau 2',
    level3Officer: 'Officier de niveau 3',
    level4Officer: 'Officier de niveau 4',
    level5Officer: 'Officier de niveau 5',
    remove: 'Supprimer',
    routeCode: 'Code de route',
    paymentRoute: 'Route de paiement',
    addPaymentRoute: 'Ajouter une route de paiement',
    goOnline: 'Passer en ligne',
    killSite: 'Arrêter le site',
    copyAllAccessControls: "Copier tous les contrôles d'accès du rôle existant",
    addNewAccessRole: "Ajouter un nouveau rôle d'accès",
    selectAll: 'Tout sélectionner',
    unselectAll: 'Tout désélectionner',
    affiliateUser: 'Utilisateur affilié',
    addAffiliateUser: 'Ajouter un utilisateur affilié',
    serverDownMessage: 'Impossible de se connecter au serveur. Veuillez réessayer dans',
    addToHomeScreen: "Ajouter à l'écran d'accueil",
    enter6DigitCode: 'Veuillez entrer le code à 6 chiffres envoyé à',
    dashboard: 'Tableau de bord',
    location: 'Emplacement',
    countryDetails:'Détails du pays',
    creditLineStatement:'Relevé de ligne de crédit',
    creditLine:'Ligne de crédit',
    transactionDetails:'Détails de la transaction',
    qualifierDetails:'Détails du qualificateur',
    adminDetails:'Détails de l’administrateur',
    receivers:'Destinataires',
    customerDetails:'Détails du client',
    paymentInstrumentMapping:'Mappage des instruments de paiement',
    grabbers:'Collecteurs',
    forexGrabbers:'Collecteurs Forex',
    forex:'Forex',
    notificationConfig:'Configuration des notifications',
    partnerDetails:'Détails du partenaire',
    addRiskImplementationClass:'Ajouter une classe d’implémentation du risque',
    riskCalculators:'Calculateurs de risque',
    riskManagement:'Gestion des risques',
    riskFactorImplementationAttached:'Implémentation du facteur de risque associée au calculateur de risque',
    attachedRiskFactor:'Classes d’implémentation des facteurs de risque associées à',
    riskFactors:'Facteurs de risque',
    paymentRouteDetails:'Détails de la route de paiement',
    routes:'Routes',
    sites:'Sites',
    userLogs:'Journaux des utilisateurs',
    userManagement:'Gestion des utilisateurs',
    affiliatePartnerUser:'Utilisateur partenaire affilié',
    affiliateDetails:'Détails de l’affilié',
    subUserDetails:'Détails du sous-utilisateur',
    paymentInstrumentDetails:'Détails de l’instrument de paiement',
    updateAccountStatus: 'Mettre à jour le statut du compte',
    userStatus: 'Statut de l’utilisateur',
    selectAdmin: 'Sélectionner un administrateur',
    selectCustomer: 'Sélectionner un client',
    selectCountry: 'Sélectionner le pays',
    selectCity: 'Sélectionner la ville',
    selectCurrencies: 'Sélectionner les devises',
    selectCurrency: 'Sélectionner la devise',
    selectPartner: 'Sélectionner le partenaire',
    selectAffiliatePartner: 'Sélectionner le partenaire affilié',
    selectSubUser: 'Sélectionner le sous-utilisateur',
    selectUser: "Sélectionner l'utilisateur",
    selectReceiver: 'Sélectionner le destinataire',
    selectAccessRole: "Sélectionner le rôle d'accès",
    selectAccessControls: "Sélectionner les contrôles d'accès",
    selectPartnerType: 'Sélectionner le type de partenaire',
    selectManagedBy: 'Sélectionner géré par',
    selectCreateUnderAdmin: "Sélectionner créer sous l'administrateur",
    selectOccupation: "Sélectionner l'occupation",
    selectRelationship: 'Sélectionner la relation',
    selectReceiverProfileType: 'Sélectionner le type de profil destinataire',
    selectCustomerProfileType: 'Sélectionner le type de profil client',
    selectPaymentDetailsSchema: 'Sélectionner le schéma de paiement',
    selectDocumentType: 'Sélectionner le type de document',
    selectModeOfPayout: 'Sélectionner le mode de versement',
    selectModeOfPayment: 'Sélectionner le mode de paiement',
    selectPaymentDetails: 'Sélectionner les détails de paiement',
    selectRiskCalculator: 'Sélectionner le calculateur de risque',
    selectImplementationClass: "Sélectionner la classe d'implémentation",
    selectImplName: "Sélectionner le nom d'implémentation",
    selectExpiryType: "Sélectionner le type d'expiration",
    selectOwner: 'Sélectionner le propriétaire',
    selectOwnerName: 'Sélectionner le nom du propriétaire',
    selectLogo: 'Sélectionner le logo',
    selectBanner: 'Sélectionner la bannière',
    selectIcon: "Sélectionner l'icône",
    selectOtpDeliveryChannel: 'Sélectionner le canal OTP',
    selectTransactionColumns: 'Sélectionner les colonnes de transaction',
    selectSenderCustomerColumns: 'Sélectionner les colonnes client expéditeur',
    selectReceiverCustomerColumns: 'Sélectionner les colonnes client destinataire',
    selectReceivingPartnerColumns: 'Sélectionner les colonnes partenaire destinataire',
    selectSendingPartnerColumns: "Sélectionner les colonnes partenaire d'envoi",
    selectTemplates: 'Sélectionner les modèles',
    enterEmail: "Saisir l'e-mail",
    enterName: 'Saisir le nom',
    enterMobileNumber: 'Saisir le numéro de mobile',
    enterDescription: 'Saisir la description',
    enterCustomUrl: "Saisir l'URL personnalisée",
    enterApplicationName: "Saisir le nom de l'application",
    enterHostedZone: 'Saisir la zone hébergée',
    enterFieldName: 'Saisir le nom du champ',
    enterFieldValue: 'Saisir la valeur du champ',
    enterRateOfRequest: 'Saisir le taux de la demande',
    enterRunIntervalValue: "Saisir la valeur de l'intervalle d'exécution",
    enterPassword: 'Saisir le mot de passe',
    enterNewPassword: 'Saisir le nouveau mot de passe',
    enterCurrentPassword: 'Saisir le mot de passe actuel',
    enterConmment: 'Saisir un commentaire',
    enterAmount: 'Saisir le montant',
    enterOccupation: 'Saisir la profession',
    enterRiskScore: 'Saisir le score de risque',
    enterAge: "Saisir l'âge",
    enterTemplateName: 'Saisir le nom du modèle',
    enterValue: 'Saisir la valeur',
    enterSMTPServerHost: "Saisir l'hôte du serveur SMTP",
    enterSMTPServerPort: 'Saisir le port du serveur SMTP',
    enterSMTPUserName: "Saisir le nom d'utilisateur SMTP",
    enterSMTPPassword: 'Saisir le mot de passe SMTP',
    enterSMTPSenderEmail: "Saisir l'e-mail expéditeur SMTP",
    enterFooterMessage: 'Saisir le message de pied de page',
    enterCF: 'Saisir CF',
    enterCFUrl: "Saisir l'URL CF",
    enterFieldRegex: 'Saisir le regex du champ',
    enterMask: 'Saisir le masque',
    enterFieldHint: "Saisir l'indice du champ",
    enterFieldDescription: 'Saisir la description du champ',
    enterExpiryAfterDays: "Saisir l'expiration après jours",
    enterAreaWghtOnCmplxFld: 'Saisir le poids de zone sur le champ complexe',
    enterRepeatMinTimes: 'Saisir le nombre min de répétitions',
    enterSelectQuery: 'Saisir la requête de sélection',
    enterSelectOptionValue: "Saisir la valeur de l'option",
    enterSelectOptionDescription: "Saisir la description de l'option",
    enterSupportEmail: "Saisir l'e-mail de support",
    enterReason: 'Saisir la raison',
    enterRelationship: 'Saisir la relation',
    enterNickName: 'Saisir le surnom',
    enterLabel: "Saisir l'étiquette",
    countryIsRequired: 'Le pays est requis',
    emailIsRequired: "L'e-mail est requis",
    nameIsRequired: 'Le nom est requis',
    firstNameIsRequired: 'Le prénom est requis',
    lastNameIsRequired: 'Le nom de famille est requis',
    passwordIsRequired: 'Le mot de passe est requis',
    mobileNumberIsRequired: 'Le numéro de mobile est requis',
    accessRoleIsRequired: "Le rôle d'accès est requis",
    accessControlsIsRequired: "Les contrôles d'accès sont requis",
    descriptionIsRequired: 'La description est requise',
    adminIsRequired: "L'administrateur est requis",
    implClassIsRequired: "La classe d'implémentation est requise",
    partnerTypeIsRequired: 'Le type de partenaire est requis',
    managedByIsRequired: 'Géré par est requis',
    createUnderAdminIsRequired: "Créer sous l'administrateur est requis",
    riskCalculationUsageIsRequired: "L'utilisation du calcul de risque est requise",
    implementationClassIsRequired: "La classe d'implémentation est requise",
    riskScoreIsRequired: 'Le score de risque est requis',
    riskGradeLevelIsRequired: 'Le niveau de grade de risque est requis',
    riskGradeThresholdIsRequired: 'Le seuil de grade de risque est requis',
    riskGradeHoldTransactionIsRequired: 'La transaction en attente est requise',
    riskGradePauseAccountIsRequired: 'Le compte en pause est requis',
    contactEmailIsRequired: "L'e-mail de contact est requis",
    contactMobileNumberIsRequired: 'Le numéro de mobile de contact est requis',
    otpDeliveryChannelIsRequired: 'Le canal de livraison OTP est requis',
    customerProfileTypeIsRequired: 'Le type de profil client est requis',
    customerIsRequired: 'Le client est requis',
    dateOfBirthIsRequired: 'La date de naissance est requise',
    countryCodeFormobilenumberIsRequired: "L'indicatif pays pour mobile est requis",
    modeOfPaymentOrPayoutIsRequired: 'Le mode de paiement ou de versement est requis',
    receiverProfileTypeIsRequired: 'Le type de profil destinataire est requis',
    queueMasterStateIsRequired: "L'état de la file d'attente est requis",
    updateTypeIsRequired: 'Le type de mise à jour est requis',
    occupationIsRequired: 'La profession est requise',
    ageIsRequired: "L'âge est requis",
    templateNameIsRequired: 'Le nom du modèle est requis',
    lcFrequencyBoundCriteriaValueIsRequired: 'La valeur du critère de fréquence LC est requise',
    smtpServerHostIsRequired: "L'hôte du serveur SMTP est requis",
    startTimeIsRequired: "L'heure de début est requise",
    endTimeIsRequired: "L'heure de fin est requise",
    fieldHintIsRequired: "L'indice du champ est requis",
    repeatMinTimesIsRequired: 'Le nombre min de répétitions est requis',
    cmplxFldOrientationIsRequired: "L'orientation du champ complexe est requise",
    selectQueryIsRequired: 'La requête de sélection est requise',
    selectOptionValueIsRequired: "La valeur de l'option est requise",
    selectOptionDescriptionIsRequired: "La description de l'option est requise",
    smtpUserNameIsRequired: "Le nom d'utilisateur SMTP est requis",
    reasonIsRequired: 'La raison est requise',
    relationshipIsRequired: 'La relation est requise',
    clientPlatformIsRequired: 'La plateforme client est requise',
    timeoutIsRequired: 'Le délai est requis',
    transactionEstimateTimeoutIsRequired: "Le délai d'estimation de transaction est requis",
    paymentDetailsSchemaIsRequired: 'Le schéma des détails de paiement est requis',
    nickNameIsRequired: 'Le surnom est requis',
    labelIsRequired: "L'étiquette est requise",
    sendingCountriesIsRequired: "Les pays d'envoi sont requis",
    receivingCountriesIsRequired: 'Les pays de réception sont requis',
    sendingCurrenciesIsRequired: "Les devises d'envoi sont requises",
    receivingCurrenciesIsRequired: 'Les devises de réception sont requises',
    currencyIsRequired: 'La devise est requise',
    amountIsRequired: 'Le montant est requis',
    timeframeIsRequired: 'La période est requise',
    timeUnitIsRequired: "L'unité de temps est requise",
    commentIsRequired: 'Le commentaire est requis',
    transactionCountLimitIsRequired: 'La limite du nombre de transactions est requise',
    expiryTypeIsRequired: "Le type d'expiration est requis",
    fromCurrencyIsRequired: 'La devise source est requise',
    toCurrencyIsRequired: 'La devise cible est requise',
    runIntervalUnitIsRequired: "L'unité d'intervalle d'exécution est requise",
    runIntervalValueIsRequired: "La valeur de l'intervalle d'exécution est requise",
    rateofRequestIsRequired: 'Le taux de requête est requis',
    ownerNameIsRequired: 'Le nom du propriétaire est requis',
    notificationBannerTypeIsRequired: 'Le type de bannière de notification est requis',
    notificationBannerDestinationIsRequired: 'La destination de la bannière est requise',
    partnerProcessorImplIsRequired: "L'implémentation du processeur partenaire est requise",
    riskCalculatorIsRequired: 'Le calculateur de risque est requis',
    riskFactorIsRequired: 'Le facteur de risque est requis',
    oneAmongContributedRiskScoreOrWeightFieldsIsRequired: "L'un des champs de score ou de poids est requis",
    onlyOneOfContributedRiskScoreOrWeightFieldsIsRequired: 'Un seul des champs de score ou de poids est requis',
    userTypeIsRequired: "Le type d'utilisateur est requis",
    userIsRequired: "L'utilisateur est requis",
  };

  constructor(private appRef: ApplicationRef) {
    // Capture any property defined on this instance into englishDict if not already present
    Object.keys(this).forEach((key) => {
      const val = (this as any)[key];
      if (typeof val === 'string' && key !== 'currentLanguage' && !this.englishDict[key]) {
        this.englishDict[key] = val;
      }
    });

    let savedLang: string | null = null;
    if (typeof window !== 'undefined' && window.localStorage) {
      try {
        savedLang = window.localStorage.getItem('selected_language');
      } catch (e) {
        savedLang = null;
      }
    }

    if (!savedLang) {
      // Auto-detect browser local language: if French -> 'fr', otherwise -> 'en'
      let detectedLang = 'en';
      if (typeof navigator !== 'undefined') {
        const browserLocale = (
          navigator.language ||
          (navigator.languages && navigator.languages[0]) ||
          (navigator as any).userLanguage ||
          ''
        ).toLowerCase();

        if (browserLocale.startsWith('fr')) {
          detectedLang = 'fr';
        }
      }
      savedLang = detectedLang;
    }

    this.setLanguage(savedLang);
  }

  public getCurrentLanguage(): string {
    return this.currentLanguage;
  }

  public setLanguage(langCode: string): void {
    const targetLang = langCode || 'en';
    const isFr = targetLang === 'fr';
    this.currentLanguage = targetLang;

    Object.keys(this.englishDict).forEach((key) => {
      if (isFr) {
        (this as any)[key] = this.frenchDict[key] || this.englishDict[key];
      } else {
        (this as any)[key] = this.englishDict[key];
      }
    });

    if (typeof window !== 'undefined' && window.localStorage) {
      try {
        window.localStorage.setItem('selected_language', targetLang);
      } catch (e) {
        console.error('Error saving selected_language to localStorage:', e);
      }
    }

    this.language$.next(targetLang);

    if (this.appRef) {
      try {
        this.appRef.tick();
      } catch (e) {
        console.warn('AppRef tick error:', e);
      }
    }
  }
}

